import { Injectable } from '@angular/core';
import { SanitizationService } from 'app/shared/utils/sanitization.service';
import { PurchasingFormService } from './purchasing-form.service';
import { APInvoiceFormService } from './ap-invoice-form.service';
import { PCardService } from './p-card.service';
import { ChangeOrderFormService } from './change-order.service';
import { RequestFormService } from './request-form.service';
import { BudgetServices } from './budget.service';
import { CheckRequestServices } from './check-request.service';
import { YeRequestFormService } from './ye-request.service';
import { NewProjectFormService } from './new-project-form.service';
import { FieldWorkRequestFormService } from './fieldwork-request.service';
import { Observable } from 'rxjs';
import { DptExpenseBudgetServices } from 'app/services/form/budget/dpt-expense-budget.service';
import { TimeSheetService } from './time-sheet.service';
import { MonthlyTimeSheetService } from './monthly-time-sheet.service';
import { InvoiceApprovalFormService } from './invoice-approval.service';
import { CCApprovalService } from './cc-approval.service';
import { AclarianTaskFormService } from './aclarian-task-form.service';
import { UserService } from '../user.service';
import { VendorFormService } from './vendor-service';
import { BidFormService } from './bid-service';
import { LicenseFormService } from '../business-license/license-services';
import { AdditionFormService } from '../capital-assets/addition-form.service';
import { DisposalFormService } from '../capital-assets/disposal-form.service';
import { TransferFormService } from '../capital-assets/transfer-frorm.service';
import { JournalEntryFormService } from '../general-ledger/journal-entry-form.service';
import { ReceiptVerificationFormService } from './receipt-verification-service';
import { CashieringReportService } from './cashiering-report.service';
import { ProjectManagementFormService } from 'app/services/form/project-mgt-form.service';
import { LeaseEvaluationService } from 'app/services/form/lease-evaluation-form.service';
import { DepartmentAdditionService } from '../general-ledger/department -addition-form.service';
import { FundAdditionService } from '../general-ledger/fund-addition-form.service';
import { EmployeeServices as HrisEmployeeServices } from '../hris/employee.service';
import { ContractApprovalFormServices } from './contract-approval-services';
import { AccountService } from '../general-ledger/account.service';
import { ProjectCloseFormService } from './project-close-service';
import { PoRolloverFormService } from './po-rollover-form.service';
import { PoRollbackFormService } from './po-rollback-form.service';
import { UtilityService } from '../utility.service';
import { ProjectOpenFormService } from './project-open-service';
import { CustomerInvoiceFromService } from '../miscellaneous-billing/customer-invoice-form.service';
import { CustomerFromService } from '../miscellaneous-billing/customer-form.service';
import { QuickInvoiceFromService } from '../miscellaneous-billing/quick-invoice-form.service';
import { QuickPayService } from './quick-pay.service';
import { QuickPayView } from 'app/models/form/QuickPayFormView';
import { WorkOrderRequestFormService } from './work-order-request.service';
import { OpenClosePeriodService } from '../general-ledger/open-close-period.service';
import { PaymentApprovalFormService } from './payment-approval-form-service';
import { BankRecService } from '../general-ledger/bank-rec-service';
import { FundingIncreaseFormService } from './funding-increase-form-service';
import { JobApplicationService } from '../hris/job-application.service';
import { VoidReissueFormService } from './void-reissue.service';
import { PaymentAdjustmentFormService } from './payment-adjustment.service';
import { BaseDashboard } from 'app/models/dashboard/BaseDashboard';
import { FormOptions, FormSearch } from 'app/models/dashboard/FormStatus';
import { HRSupportView } from 'app/models/form/HRSupportView';
import { BudgetAmendmentView } from 'app/models/form/BudgetAmendmentView';
import { CheckRequestView } from 'app/models/form/CheckRequestView';
import { environment } from 'environments/environment';
import { ProjectGrantFormService } from '../project-grant/project-grant-form.service';
import { ProjectGrantTaskService } from '../project-grant/project-grant-task-service';
import { ProjectGrantCloseService } from '../project-grant/project-grant-close-service';
import { ProjectGrantReOpenService } from '../project-grant/project-grant-reopen-service';
import { EmployeeActionFromService } from '../hris/employee-action-form.service';
import { TimeOffService } from '../hris/time-off.service';
import { HrisTimeSheetService } from '../hris/weekly-timesheet.service';
import { DepreciationScheduleFormService } from '../capital-assets/depreciation-schedule-form.service';
import { NewDebtIssuanceService } from '../debt-management/new-debt-issuance.service';
import { DebtServicePaymentService } from '../debt-management/debt-service-payment.service';
import { DebtCovenantComplianceService } from '../debt-management/debt-covenant-compliance.service';
import { DebtInvestmentJournalEntryService } from '../debt-management/debt-investment-je.service';
import { InvestmentSecurityPurchaseService } from '../debt-management/investment-security-purchase.service';
import { BenefitsEnrolmentService } from '../hris/benefit-enrolment.service';
import { PerformanceEvaluationService } from '../hris/performance-evaluation.service';
import { CashReceiptFormService } from '../miscellaneous-billing/cash-receipt-form.service';
import { CreditCardReportService } from './credit-card-report.service';
import { IndividualPayeeFormService } from './individual-payee-form.service';
import { IndividualPaymentService } from './individual-payment.service';
import { ImplementationService } from './implementation.service';
import { ImplementationGeneralLedgerService } from './implementation-general-ledger.service';
import { CustomerRefundFormService } from './customer-refund-form.service';
import { NewCapitalLeaseService } from '../capital-lease/new-capital-lease.service';
import { LeaseModificationService } from '../capital-lease/lease-modification.service';
import { UsageFormService } from '../Inventory/usage-form.service';
import { RecurringTemplateService } from '../recurring-template.service';
import { ImplementationPurchasingService } from './implementation-purchasing.service';
import { LeaveBalanceAdjustmentFormService } from '../hris/leave-balance-adjustment-form.service';
import { ImplementationPaymentService } from './implementation-payment.service';
import { WorkflowGroupService } from '../workflowgroup.service';
import { UserWorkflowFormService } from './user-workflow-form.service';
import { GlSegmentation } from 'app/models/segment-labeling-gl-strings/GlSegmentation';
import { TimesheetApprovalFormService } from '../hris/timesheet-approval-form.service';
import { FundRevenueBudgetServices } from 'app/services/form/budget/fund-revenue-budget.service';
import { CapitalBudgetServices } from 'app/services/form/budget/capital-budget.service';
import { PersonnelBudgetServices } from 'app/services/form/budget/personnel-budget.service';
import { CustomerInvoiceAdjustmentFormService } from '../miscellaneous-billing/customer-invoice-adjustment-form.service';
import { ImplementationHrService } from './implementation-hr.service';
import { TravelPreApprovalService } from './travel-pre-approval-form.service';
import { TravelReimbursementService } from './travel-reimbursement-form.service';
import { ReclassificationFormService } from 'app/services/capital-assets/reclassification-form-service';
import { BaseFormService } from 'app/services/BaseFormService';
import { ElectronicAchReportService } from './electronic-ach-report.service';
import { ComplainantFormService } from '../code-enforcement/complainant-service';
import { ReclassificationForm } from 'app/models/capital-asset/ReclassificationForm';
import { AssetAdditionType } from 'app/models/capital-asset/AssetAdditionType';
import { TaxDistributionService } from './tax-distribution.service';
import { TuitionReimbursementService } from './tuition-reimbursement-form.service';
import { TuitionReimbursementPaymentService } from './tuition-reimbursement-payment-form.service';
import { PurchasingEmployeeService } from '../purchasing/purchasing-employee-service';
import { TaxingJurisdictionService } from '../purchasing/taxing-jurisdiction-service';
import { OtherReimbursableExpensesService } from './other-reimbursable-expenses-form.service';
import { LocalVicinityTravelService } from './local-vicinity-travel-form.service';
import { OutOfCountyTravelService } from './out-of-county-travel-form.service';
import { AnnouncementService } from '../Announcement/announcement.service';
import { FiservRefundFormService } from './fiserv-refund-form.service';
import { SpecialPayService } from '../hris/special-pay-from.service';
import { TuitionReimbPreApprovalFormService } from './tuition-reimb-pre-approval-form.service';
import { InvestmentIncomeAllocationService } from './investment-income-allocation-form.service';
import { IndividualRefundService } from './individual-refund-form.service';
import { TaxCertificateRedemptionCheckService } from './tax-certificate-redemption-check-form.service';
import { TaxCertificateRedemptionACHFormService } from './tax-certificate-redemption-ach-form.service';
import { GoLiveApprovalFormService } from './go-live-approval-form.service';
import { TrainingCertificationFormService } from './training-certification-form.service';
import { LocationService } from '../Inventory/location.service';
import { ItemService } from '../Inventory/item.service';
import { ReceivingFormService } from '../Inventory/receiving-form.service';
import { CashBondFormService } from './cash-bond-form.service';
import { JuryCheckRegistryService } from './jury-check-registry-form.service';
import { MassPayRateChangeService } from '../hris/mass-pay-rate-change.service';
import { AdjustmentFormService } from '../Inventory/adjustment-form.service';
import { ImplementationPayrollService } from './implementation-payroll.service';
import { MultiplePaymentServices } from './multiple-payment.service';
import { MultipleVendorPaymentServices } from './multiple-vendor-payment.service';
import { ProjectGrantLinkageFormService } from '../project-grant/project-grant-linkage-form.service';
import { LeaveBalancePayoutService } from '../hris/leave-balance-payout-form.service';
import { PayrollAdjustmentService } from '../hris/payroll-adjustment.service';
import { OtherBankRecService } from '../general-ledger/other-bank-rec-service';
import { BudgetTransferView } from 'app/models/form/BudgetTransferView';
import { IndividualRefundView } from 'app/models/form/IndividualRefundView';
import { AssetWorkOrderFormService } from 'app/services/capital-assets/asset-work-order-form.service';
import { CapitalBudgetView } from 'app/models/form/CapitalBudgetView';
import { TaxCertificateRedemptionCheckView } from 'app/models/form/TaxCertificateRedemptionCheckView';
import { OtherTuitionReimbursementService } from './other-tuition-reimbursement.service';
import { OtherTuitionReimbursementPaymentService } from './other-tuition-reimbursement-payment.service';
import { OpenClosePeriodFormView } from 'app/models/general-ledger/OpenClosePeriodFormView';
import { OperatingExpenseBudgetServices } from 'app/services/form/budget/operating-expense-budget.service';
import { CustomerCreditMemoService } from '../miscellaneous-billing/customer-credit-memo.service';
import { VendorCreditMemoService } from './vendor-credit-memo-form.service';
import { CashBondPaymentFormService } from './cash-bond-payment-form.service';
import { RestitutionPaymentFormService } from './restitution-payment-form.service';
import { CustomerFeedbackSurveyService } from './customer-feedback-survey.service';
import { FieldPaymentRequestFormService } from './field-payment-request-form.service';
import { DailyFeesImportFormService } from '../Cashiering/daily-fees-import-form.services';
import { SpecialPaymentServices } from 'app/services/form/special-payment.service';
import { InitialPurchaseRequestFormService } from './initial-purchase-request-form.service';
import { BulkCashReceiptFormService } from '../miscellaneous-billing/bulk-cash-receipt-form.service';
import { IndividualPaymentView } from 'app/models/form/individualPaymentView';
import { CashieringAdjustmentFormFormService } from '../miscellaneous-billing/cashiering-adjustment-form.service';
import { CashieringCloseoutReportService } from './cashiering-closeout-report.service';
import { VendorInformationChangeRequestService } from './vendor-information-change-request-form.service';
import { EmployeeReimbursableExpensesService } from './employee-reimbursable-expenses-form.service';
import { ContractAmendmentFormServices } from './contract-amendment-services';
import { ParentVendorFormService } from './parent-vendor-service';
import { NewHireRequestFormService } from './budget/new-hire-request.service';
import { OutOfCountyTravelAdjustmentFormService } from './out-of-county-travel-adjustment-form.service';
import { TravelReimbursementPaymentService } from './travel-reimbursement-payment-form.service';
import { CostAllocationFormService } from '../project-grant/cost-allocation-form.service';
import { EnhancementRequestFormService } from '../client-support/enhancement-request-form.service';

import { PolicyFormService } from 'app/services/policies-and-procedures/policy-form.service';
import { ProcedureFormService } from 'app/services/policies-and-procedures/procedure-form.service';
import { CustomizedTaskFormService } from './task-management/customized-task-form.services';
import { ProjectGrantComplianceFormService } from '../project-grant/project-grant-compliance-form.service';
import { SupportRequestService } from './support-request.service';
import { ThirdPartyIntegrationFormService } from '../Cashiering/third-party-integration/third-party-integration-form.service';
import { InvestmentActivityRecordingService } from './investment-activity-recording-form.service';
import { CustomizationRequestFormService } from '../client-implementation/customization-request.service';
import { AccessChangeFormService } from './access-change-form.service';
import { MassInvoiceCreationFormService } from '../miscellaneous-billing/mass-invoice-creation-form.service';
import { BillingFormService } from '../billing-forms/billing-form.service';
declare const moment: any;
declare const $: any;

@Injectable({
	providedIn: 'root',
})
export class FormUtilityService {
	private readonly userId: string;
	private readonly clientId: string;
	private readonly glSegmentation: GlSegmentation;
	protected formServiceMap: { [key in FormOptions]?: any };

	constructor(
		private purchasingFormService: PurchasingFormService,
		private apInvoiceService: APInvoiceFormService,
		private pCardService: PCardService,
		private changeOrderService: ChangeOrderFormService,
		private requestFormService: RequestFormService,
		private budgetService: BudgetServices,
		private dptExpenseBudgetServices: DptExpenseBudgetServices,
		private checkRequestService: CheckRequestServices,
		private yeRequestService: YeRequestFormService,
		private hrSupportService: SupportRequestService,
		private newProjectFormService: NewProjectFormService,
		private timeSheetFormService: TimeSheetService,
		private monthlyTimeSheetService: MonthlyTimeSheetService,
		private fieldworkRequestService: FieldWorkRequestFormService,
		private invoiceApprovalService: InvoiceApprovalFormService,
		private ccApprovalService: CCApprovalService,
		private aclarianTaskService: AclarianTaskFormService,
		private vendorService: VendorFormService,
		private userService: UserService,
		private fundRevenueBudgetService: FundRevenueBudgetServices,
		private capitalBudgetService: CapitalBudgetServices,
		private bidService: BidFormService,
		private licenseFormService: LicenseFormService,
		private capitalAdditionService: AdditionFormService,
		private disposalFormService: DisposalFormService,
		private transferFormService: TransferFormService,
		private journalEntryFormService: JournalEntryFormService,
		private receiptVerificationFormService: ReceiptVerificationFormService,
		private cashieringReportService: CashieringReportService,
		private projectManagementService: ProjectManagementFormService,
		private leaseEvaluationService: LeaseEvaluationService,
		private departmentAdditionService: DepartmentAdditionService,
		private fundAdditionService: FundAdditionService,
		private personnelBudgetServices: PersonnelBudgetServices,
		private paymentApprovalFormService: PaymentApprovalFormService,
		private contractApprovalFormServices: ContractApprovalFormServices,
		private accountService: AccountService,
		private poRolloverService: PoRolloverFormService,
		private poRollbackService: PoRollbackFormService,
		private projectCloseService: ProjectCloseFormService,
		private utilityService: UtilityService,
		private projectOpenService: ProjectOpenFormService,
		private customerInvoiceFormService: CustomerInvoiceFromService,
		private customerFormService: CustomerFromService,
		private quickPayService: QuickPayService,
		private bankRecService: BankRecService,
		private workOrderRequestService: WorkOrderRequestFormService,
		private openClosePeriodService: OpenClosePeriodService,
		private fundingIncreaseFormService: FundingIncreaseFormService,
		private jobApplicationWorkflowService: JobApplicationService,
		private employeeActionFromService: EmployeeActionFromService,
		private voidReissueFormService: VoidReissueFormService,
		private paymentAdjustmentFormService: PaymentAdjustmentFormService,
		private timeOffService: TimeOffService,
		private hrisTimeSheetService: HrisTimeSheetService,
		private hrisPerformanceEvaluationService: PerformanceEvaluationService,
		private benefitsEnrolmentService: BenefitsEnrolmentService,
		private cashReceiptFormService: CashReceiptFormService,
		private creditCardReportService: CreditCardReportService,
		private individualPayeeFormService: IndividualPayeeFormService,
		private individualPaymentFormService: IndividualPaymentService,
		private quickInvoiceFormService: QuickInvoiceFromService,
		private projectGrantFormService: ProjectGrantFormService,
		private projectGrantTaskService: ProjectGrantTaskService,
		private projectGrantCloseService: ProjectGrantCloseService,
		private capitalLeaseService: NewCapitalLeaseService,
		private capitalLeaseModificationService: LeaseModificationService,
		private projectGrantReOpenServic: ProjectGrantReOpenService,
		private depreciationScheduleFormService: DepreciationScheduleFormService,
		private newDebtIssuanceService: NewDebtIssuanceService,
		private debtServicePaymentService: DebtServicePaymentService,
		private debtCovenantComplianceService: DebtCovenantComplianceService,
		private debtInvestmentJournalEntryService: DebtInvestmentJournalEntryService,
		private investmentSecurityPurchaseService: InvestmentSecurityPurchaseService,
		private customerRefundFormService: CustomerRefundFormService,
		private implBillingService: ImplementationService,
		private implGLService: ImplementationGeneralLedgerService,
		private usageFormService: UsageFormService,
		private newHireService: HrisEmployeeServices,
		private templateService: RecurringTemplateService,
		private impPurService: ImplementationPurchasingService,
		private leaveBalanceAdjustmentFormService: LeaveBalanceAdjustmentFormService,
		private impPayService: ImplementationPaymentService,
		private workflowGroupService: WorkflowGroupService,
		private userWorkflowFormService: UserWorkflowFormService,
		private timesheetApprovalForm: TimesheetApprovalFormService,
		private customerInvoiceAdjustmentFormService: CustomerInvoiceAdjustmentFormService,
		private impHRService: ImplementationHrService,
		private travelPreApprovalService: TravelPreApprovalService,
		private travelReimbursementService: TravelReimbursementService,
		private reclassificationFormService: ReclassificationFormService,
		private electronicAchReportService: ElectronicAchReportService,
		private complainantFormService: ComplainantFormService,
		private taxDistributionSerivce: TaxDistributionService,
		private tuitionReimbursementService: TuitionReimbursementService,
		private tuitionReimbursementPaymentService: TuitionReimbursementPaymentService,
		private purchasingEmployeeService: PurchasingEmployeeService,
		private taxingJurisdictionService: TaxingJurisdictionService,
		private fiservRefundFormService: FiservRefundFormService,
		private specialPayService: SpecialPayService,
		private tuitionReimbPreApprovalService: TuitionReimbPreApprovalFormService,
		private investmentIncomeAllocationFormService: InvestmentIncomeAllocationService,
		private otherReimbursableExpensesService: OtherReimbursableExpensesService,
		private localVicinityTravelService: LocalVicinityTravelService,
		private outofCountyTravelService: OutOfCountyTravelService,
		private announcementService: AnnouncementService,
		private individualRefundService: IndividualRefundService,
		private taxCertificateRedemptionCheckService: TaxCertificateRedemptionCheckService,
		private taxCertificateRedemptionACHFormService: TaxCertificateRedemptionACHFormService,
		private goLiveApprovalFormService: GoLiveApprovalFormService,
		private trainingCertificationFormService: TrainingCertificationFormService,
		private locationFormService: LocationService,
		private itemService: ItemService,
		private ReceivingFormService: ReceivingFormService,
		private cashBondFormService: CashBondFormService,
		private juryCheckRegistryService: JuryCheckRegistryService,
		private massPayRateChangeServices: MassPayRateChangeService,
		private adjustmentFormService: AdjustmentFormService,
		private impPayrollService: ImplementationPayrollService,
		private multiplePaymentService: MultiplePaymentServices,
		private multipleVendorPaymentService: MultipleVendorPaymentServices,
		private projectGrantLinkageFormService: ProjectGrantLinkageFormService,
		private leaveBalancePayoutService: LeaveBalancePayoutService,
		private payrollAdjustmentService: PayrollAdjustmentService,
		private otherBankRecService: OtherBankRecService,
		private assetWorkOrderFormService: AssetWorkOrderFormService,
		private operatingExpenseBudgetServices: OperatingExpenseBudgetServices,
		private customerCreditMemoService: CustomerCreditMemoService,
		private vendorCreditMemoService: VendorCreditMemoService,
		private otherTuitionReimbursementService: OtherTuitionReimbursementService,
		private otherTuitionReimbursementPaymentService: OtherTuitionReimbursementPaymentService,
		private cashBondPaymentService: CashBondPaymentFormService,
		private restitutionPaymentService: RestitutionPaymentFormService,
		private customerFeedbackSurveyService: CustomerFeedbackSurveyService,
		private fieldPaymentRequestFormService: FieldPaymentRequestFormService,
		private specialPaymentService: SpecialPaymentServices,
		private initialPurchaseRequestFormService: InitialPurchaseRequestFormService,
		private bulkCashReceiptFormService: BulkCashReceiptFormService,
		private readonly dailyFeesImportFormService: DailyFeesImportFormService,
		private cashieringAdjustmentFormService: CashieringAdjustmentFormFormService,
		private cashieringCloseoutReportService: CashieringCloseoutReportService,
		private readonly vendorInformationChangeRequestService: VendorInformationChangeRequestService,
		private readonly employeeReimbursableExpensesService: EmployeeReimbursableExpensesService,
		private readonly contractAmendmentService: ContractAmendmentFormServices,
		private readonly parentVendorService: ParentVendorFormService,
		private readonly newHireRequestFormService: NewHireRequestFormService,
		private readonly policyFormService: PolicyFormService,
		private readonly procedureFormService: ProcedureFormService,
		private readonly outOfCountyTravelAdjustmentFormService: OutOfCountyTravelAdjustmentFormService,
		private readonly travelreimbursementPaymentService: TravelReimbursementPaymentService,
		private readonly customizedTaskFormService: CustomizedTaskFormService,
		private readonly enhancementRequestFormService: EnhancementRequestFormService,
		private costAllocationFormService: CostAllocationFormService,
		private readonly projectGrantComplianceFormService: ProjectGrantComplianceFormService,
		private readonly thirdPartyIntegrationFormService: ThirdPartyIntegrationFormService,
		private readonly investmentActivityRecordingService: InvestmentActivityRecordingService,
		private readonly customizationRequestFormService: CustomizationRequestFormService,
		private readonly accessChangeFormService: AccessChangeFormService,
		private readonly massInvoiceCreationFormService: MassInvoiceCreationFormService,
		private readonly billingFormService: BillingFormService,
		private readonly sanitizationService: SanitizationService
	) {
		this.userId = this.userService.currentUserValue.user.id;
		this.clientId = this.userService.currentUserValue.user.clientId;
		this.glSegmentation = this.utilityService.getGlSegmentation(this.clientId);
	}

	getTableData({
		clientId,
		userId,
		formOption,
		search,
	}: {
		clientId: string;
		userId: string;
		formOption: FormOptions;
		search: FormSearch;
	}): Observable<BaseDashboard<any>> {
		switch (formOption) {
			case FormOptions.Purchasing:
				return this.purchasingFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.Request:
				return this.requestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ChangeOrder:
				return this.changeOrderService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.APInvoice:
				return this.apInvoiceService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PCard:
				return this.pCardService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BudgetTransfer:
				return this.budgetService.getDashboardBudgetTransfer(clientId, userId, search).pipe();
			case FormOptions.BudgetAmendment:
				return this.budgetService.getDashboardBudgetAmendment(clientId, userId, search).pipe();
			case FormOptions.DptExpenseBudget:
				return this.dptExpenseBudgetServices.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CheckRequest:
				return this.checkRequestService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.YeRequest:
				return this.yeRequestService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.FieldWorkRequest:
				return this.fieldworkRequestService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NewProject:
				return this.newProjectFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.HRSupport:
				return this.hrSupportService.getFormsFor(userId, search).pipe();
			case FormOptions.TimeSheet:
				return this.timeSheetFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.MonthlyTimeSheet:
				return this.monthlyTimeSheetService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.InvoiceApproval:
				return this.invoiceApprovalService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CCApproval:
				return this.ccApprovalService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.AclarianTask:
				return this.aclarianTaskService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.VendorForm:
				return this.vendorService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BidForm:
				return this.bidService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NYRevenueBudget:
				return this.fundRevenueBudgetService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NYCapitalBudget:
				return this.capitalBudgetService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BusinessLicense:
				return this.licenseFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CapitalAdditionForm:
				return this.capitalAdditionService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CapitalDisposalForm:
				return this.disposalFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CapitalTransferForm:
				return this.transferFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.JournalEntryForm:
				return this.journalEntryFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ReceiptVerification:
				return this.receiptVerificationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CashieringReport:
				return this.cashieringReportService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectManagement:
				return this.projectManagementService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.LeaseEvaluation:
				return this.leaseEvaluationService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.DepartmentAdditionForm:
				return this.departmentAdditionService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.FundAdditionForm:
				return this.fundAdditionService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PersonnelManagement:
				return this.personnelBudgetServices.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.FundingIncreaseForm:
				return this.fundingIncreaseFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PaymentApprovalForm:
				return this.paymentApprovalFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ContractApproval:
				return this.contractApprovalFormServices.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.AccountCreation:
				return this.accountService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectCloseForm:
				return this.projectCloseService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PoRolloverForm:
				return this.poRolloverService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PoRollbackForm:
				return this.poRollbackService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectOpenForm:
				return this.projectOpenService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomerInvoiceForm:
				return this.customerInvoiceFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomerForm:
				return this.customerFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.QuickInvoiceForm:
				return this.quickInvoiceFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.QuickPayForm:
				return this.quickPayService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BankReconciliation:
				return this.bankRecService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.WorkOrderRequestForm:
				return this.workOrderRequestService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OpenClosePeriod:
				return this.openClosePeriodService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.JobApplication:
				return this.jobApplicationWorkflowService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.EmployeeActionForm:
				return this.employeeActionFromService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.VoidReissueForm:
				return this.voidReissueFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PaymentAdjustmentForm:
				return this.paymentAdjustmentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TimeOff:
				return this.timeOffService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.HrisTimeSheet:
				return this.hrisTimeSheetService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PerformanceEvaluation:
				return this.hrisPerformanceEvaluationService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BenefitEnrolmentForm:
				return this.benefitsEnrolmentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CashReceiptForm:
				return this.cashReceiptFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CreditCardReport:
				return this.creditCardReportService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.IndividualPayeeForm:
				return this.individualPayeeFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.IndividualPaymentForm:
				return this.individualPaymentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectGrantForm:
				return this.projectGrantFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectGrantTask:
				return this.projectGrantTaskService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectGrantCloseForm:
				return this.projectGrantCloseService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectGrantReopenForm:
				return this.projectGrantReOpenServic.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.DepreciationScheduleForm:
				return this.depreciationScheduleFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NewDebtIssuanceForm:
				return this.newDebtIssuanceService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.DebtServicePaymentForm:
				return this.debtServicePaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.DebtCovenantComplianceForm:
				return this.debtCovenantComplianceService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.DebtInvestmentJournalEntryForm:
				return this.debtInvestmentJournalEntryService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.InvestmentSecurityPurchaseForm:
				return this.investmentSecurityPurchaseService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomerRefundForm:
				return this.customerRefundFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NewCapitalLeaseForm:
				return this.capitalLeaseService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.LeaseModificationForm:
				return this.capitalLeaseModificationService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.Implementation:
				return this.implBillingService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ImplementationGL:
				return this.implGLService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.UsageForm:
				return this.usageFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NewHireForm:
				return this.newHireService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.RecurringTemplate:
				return this.templateService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ImplementationPurchasing:
				return this.impPurService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.LeaveBalanceAdjustmentForm:
				return this.leaveBalanceAdjustmentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ImplementationPayment:
				return this.impPayService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.WorkflowGroup:
				return this.workflowGroupService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.UserWorkflowForm:
				return this.userWorkflowFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TimeSheetApprovalForm:
				return this.timesheetApprovalForm.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomerInvoiceAdjustmentForm:
				return this.customerInvoiceAdjustmentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ImplementationHR:
				return this.impHRService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TravelPreApprovalForm:
				return this.travelPreApprovalService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TravelReimbursementForm:
				return this.travelReimbursementService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CapitalReclassification:
				return this.reclassificationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ElectronicAchReport:
				return this.electronicAchReportService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.RequestForm:
				return this.requestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ComplainantForm:
				return this.complainantFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TaxDistributionForm:
				return this.taxDistributionSerivce.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TuitionReimbursementForm:
				return this.tuitionReimbursementService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TuitionReimbursementPaymentForm:
				return this.tuitionReimbursementPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PurchasingEmployee:
				return this.purchasingEmployeeService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TaxingJurisdiction:
				return this.taxingJurisdictionService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OtherReimbursableExpensesForm:
				return this.otherReimbursableExpensesService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.LocalVicinityTravelForm:
				return this.localVicinityTravelService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OutofCountyTravelForm:
				return this.outofCountyTravelService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.Announcements:
				return this.announcementService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.FiservRefundForm:
				return this.fiservRefundFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.SpecialPayForm:
				return this.specialPayService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TuitionReimbPreApprovalForm:
				return this.tuitionReimbPreApprovalService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.InvestmentIncomeAllocationForm:
				return this.investmentIncomeAllocationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.IndividualRefundForm:
				return this.individualRefundService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TaxCertificateRedemptionCheckForm:
				return this.taxCertificateRedemptionCheckService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TaxCertificateRedemptionACHForm:
				return this.taxCertificateRedemptionACHFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.GoLiveApprovalForm:
				return this.goLiveApprovalFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TrainingCertificationForm:
				return this.trainingCertificationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.LocationForm:
				return this.locationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ItemForm:
				return this.itemService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ReceivingForm:
				return this.ReceivingFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CashBondForm:
				return this.cashBondFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.JuryCheckRegistryForm:
				return this.juryCheckRegistryService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.MassPayRateChangeForm:
				return this.massPayRateChangeServices.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.AdjustmentForm:
				return this.adjustmentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ImplementationPayroll:
				return this.impPayrollService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.MultiplePayment:
				return this.multiplePaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.MultipleVendorPayment:
				return this.multipleVendorPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TransactionAssignmentForm:
				return this.projectGrantLinkageFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.LeaveBalancePayoutForm:
				return this.leaveBalancePayoutService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PayrollAdjustmentForm:
				return this.payrollAdjustmentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OtherBankReconciliation:
				return this.otherBankRecService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.SpecialPayment:
				return this.specialPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CapitalWorkOrderForm:
				return this.assetWorkOrderFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NYOperatingExpenseBudget:
				return this.operatingExpenseBudgetServices.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomerCreditMemo:
				return this.customerCreditMemoService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.VendorCreditMemo:
				return this.vendorCreditMemoService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OtherTuitionReimbursementForm:
				return this.otherTuitionReimbursementService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OtherTuitionReimbursementPaymentForm:
				return this.otherTuitionReimbursementPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CashBondPaymentForm:
				return this.cashBondPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.RestitutionPaymentForm:
				return this.restitutionPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomerFeedbackSurveyForm:
				return this.customerFeedbackSurveyService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.FieldRequestPaymentForm:
				return this.fieldPaymentRequestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.InitialPurchaseRequestForm:
				return this.initialPurchaseRequestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BulkCashReceiptForm:
				return this.bulkCashReceiptFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.DailyFeesImportForm:
				return this.dailyFeesImportFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CashieringAdjustmentForm:
				return this.cashieringAdjustmentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CashieringCloseoutReport:
				return this.cashieringCloseoutReportService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.VendorInformationChangeRequestForm:
				return this.vendorInformationChangeRequestService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.EmployeeReimbursableExpensesForm:
				return this.employeeReimbursableExpensesService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CostAllocationForm:
				return this.costAllocationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ContractAmendment:
				return this.contractAmendmentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ParentVendorForm:
				return this.parentVendorService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.NewHireRequestForm:
				return this.newHireRequestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.PolicyForm:
				return this.policyFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProcedureForm:
				return this.procedureFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.OutofCountyTravelAdjustmentForm:
				return this.outOfCountyTravelAdjustmentFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.TravelReimbursementPaymentForm:
				return this.travelreimbursementPaymentService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomizedTaskForm:
				return this.customizedTaskFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.EnhancementRequestForm:
				return this.enhancementRequestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ProjectGrantComplianceForm:
				return this.projectGrantComplianceFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.ThirdPartyIntegrationForm:
				return this.thirdPartyIntegrationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.InvestmentActivityRecordingForm:
				return this.investmentActivityRecordingService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.CustomizationRequestForm:
				return this.customizationRequestFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.AccessChangeForm:
				return this.accessChangeFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.MassInvoiceCreationForm:
				return this.massInvoiceCreationFormService.getFormsFor(clientId, userId, search).pipe();
			case FormOptions.BillingForm:
				return this.billingFormService.getFormsFor(clientId, userId, search).pipe();
			default:
				return undefined;
		}
	}

	getTableOptions(dashboardData: BaseDashboard<any>, formOption: FormOptions, appendQueryString = false): any {
		const baseOptions = this.tableOptionBase(dashboardData, false);
		switch (formOption) {
			case FormOptions.Purchasing:
				baseOptions.columns = [
					{
						title: 'PO Type',
						data: 'poType',
						mRender: (data) => {
							const poTypes = [
								{ id: 1, name: 'Itemized Services' },
								{ id: 2, name: 'Itemized Goods' },
								{ id: 3, name: 'Itemized Goods & Services' },
								{ id: 4, name: 'Single Good/Service or Blanket PO' },
								{ id: 5, name: 'Construction Expenses' },
							];
							const poType = poTypes.find((x) => x.id === data);
							return poType != null ? poType.name : '';
						},
					},
					{
						title: 'Po Number',
						data: 'poNumber',
						mRender: (data) => {
							return data ? data : 'N/A';
						},
					},
					{ title: 'REQ Reference ID', data: 'reqReferenceId', bSortable: true },
					{ title: 'Vendor Name', data: 'vendor' },
					{
						title: 'Total Po Amount',
						data: 'totalpOAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Goods and Services Requested',
						data: 'description',
						render: (data, type) => {
							if (type === 'display') return this.sanitizationService.sanitizeHtml(data || '');
							return this.stripHtml(data);
						},
					},
					{ title: 'Fiscal Year', data: 'fiscalYear' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},

					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.Purchasing}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.Request:
				baseOptions.columns = [
					{ title: 'Task Name', data: 'taskName' },
					{ title: 'Frequency', data: 'frequency' },
					{ title: 'Assign To', data: 'assignedToUserName' },
					{ title: 'Due Date', data: 'dueDate' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.Request}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ChangeOrder:
				baseOptions.columns = [
					{ title: 'PO Number', data: 'poNumber' },
					{ title: 'Vendor Name', data: 'originalVendor' },
					{
						title: 'Original Amount',
						data: 'originalAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Revised Amount',
						data: 'revisedAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ChangeOrder}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.APInvoice:
				baseOptions.columns = [
					{ title: 'PO Number', data: 'poNumber', bSortable: true },
					{
						title: 'PO Amount',
						data: 'poAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{ title: 'Vendor', data: 'vendor' },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Invoice Number', data: 'invoiceNumber', bSortable: true },
					{
						title: 'Invoice Amount',
						data: 'invoiceAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: null,
						bSortable: true,
						mRender: (data) => {
							let val = '';
							if (data?.requestedByEmails?.length > 0) {
								for (const item of data.requestedByEmails) {
									val += `${item}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Delegate Allowed?',
						data: 'isDelegateAllowed',
						bSortable: false,
						mRender: (data) => {
							return data ? 'Yes' : 'No';
						},
					},
					{
						title: 'Delegated By',
						data: 'delegatedByName',
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.APInvoice}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PCard:
				baseOptions.columns = [
					{
						title: 'Statement End Date',
						data: 'statementEndDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Card Holder', data: 'cardHolder', bSortable: true },
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PCard}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BudgetTransfer:
				baseOptions.columns = [
					{ title: 'FUND', data: 'fundName', bSortable: true },
					{ title: 'DEPARTMENT', data: 'department', bSortable: true },
					{
						title: 'GL ACCOUNT',
						data: null,
						bSortable: false,
						mRender: (data: BudgetTransferView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedger}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'ORIGINAL BUDGET AMOUNT',
						data: null,
						bSortable: false,
						mRender: (data: BudgetTransferView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${this.utilityService.formatCurrency(item.originalAmount)}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'REQUESTED INCREASE/DECREASE',
						data: null,
						bSortable: false,
						mRender: (data: BudgetTransferView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${this.utilityService.formatCurrency(item.revisedAmount)}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'STATUS',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'REQUESTED BY', data: 'requestedBy', bSortable: true },
					{
						title: 'CREATED DATE',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BudgetTransfer}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BudgetAmendment:
				baseOptions.columns = [
					{
						title: 'FUND',
						data: null,
						bSortable: false,
						mRender: (data: BudgetAmendmentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									if (item.fundName) {
										val += `${item.fundName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'DEPARTMENT',
						data: null,
						bSortable: false,
						mRender: (data: BudgetAmendmentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									if (item.department) {
										val += `${item.department}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'GL ACCOUNT',
						data: null,
						bSortable: false,
						mRender: (data: BudgetAmendmentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedger}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'ORIGINAL AMOUNT',
						data: null,
						bSortable: false,
						mRender: (data: BudgetAmendmentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${this.utilityService.formatCurrency(item.originalAmount)}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'REVISED AMOUNT',
						data: null,
						bSortable: false,
						mRender: (data: BudgetAmendmentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${this.utilityService.formatCurrency(item.revisedAmount)}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'STATUS',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'REQUESTED BY', data: 'requestedBy', bSortable: true },
					{
						title: 'CREATED DATE',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BudgetAmendment}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DptExpenseBudget:
				baseOptions.order = [[0, 'asc']];
				baseOptions.columns = [
					{
						title: 'Fiscal Year',
						data: 'fiscalYear',
						bSortable: true,
					},
					{
						title: 'Department',
						bSortable: true,
						data: null,
						mRender: (data) => {
							return `${data.department} (${data.departmentId})`;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DptExpenseBudget}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CheckRequest:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Vendor Name', data: 'vendor', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Description', data: 'description', bSortable: true },
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data && data.accounts.length > 0) {
								const totalAmount = data.accounts
									.filter((x) => x.amount)
									.map((x) => x.amount)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							} else {
								return this.utilityService.formatCurrency(data.totalPaymentAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: null,
						bSortable: true,
						mRender: (data) => {
							let val = '';
							if (data?.requestedByEmails?.length > 0) {
								for (const item of data.requestedByEmails) {
									val += `${item}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) {
								return '';
							}
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Delegate Allowed?',
						data: 'isDelegateAllowed',
						bSortable: false,
						mRender: (data) => {
							return data ? 'Yes' : 'No';
						},
					},
					{
						title: 'Delegated By',
						data: 'delegatedByName',
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CheckRequest}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.YeRequest:
				baseOptions.columns = [
					{ title: 'Task Name', data: 'taskName', bSortable: true },
					{ title: 'Request List Item Number', data: 'listItemNumber', bSortable: true },
					{ title: 'Request Crowe Exchange', data: 'croweExchangeItem', bSortable: true },
					{ title: 'Assign To', data: 'assignedTo', bSortable: true },
					{
						title: 'Due Date',
						data: 'dueDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.YeRequest}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.FieldWorkRequest:
				baseOptions.order = [[2, 'asc']];
				baseOptions.columns = [
					{ title: 'Request List Item Number', data: 'listItemNumber', bSortable: true },
					{ title: 'Audit Area', data: 'nameOfAuditArea', bSortable: true },
					{ title: 'Assign To', data: 'assignedTo', bSortable: true },
					{
						title: 'Due Date',
						data: 'dueDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},

					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FieldWorkRequest}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewProject:
				baseOptions.columns = [
					{ title: 'Project Title', data: 'title' },
					{ title: 'Project Manager', data: 'projectManagerName' },
					{ title: 'Department', data: 'department' },
					{
						title: 'Start Date',
						data: 'startDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Projected End Date',
						data: 'endDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewProject}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.HRSupport:
				baseOptions.columns = [
					{
						title: 'Request',
						data: null,
						bSortable: false,
						mRender: (data: HRSupportView) => {
							let val = '';
							if (data?.requests?.length > 0) {
								for (const item of data.requests) {
									if (item.areaName) {
										val += `${item.areaName}`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Document Name',
						data: null,
						bSortable: false,
						mRender: (data: HRSupportView) => {
							let val = '';
							if (data?.requests?.length > 0) {
								for (const item of data.requests) {
									if (item.formName) {
										val += `${item.formName}`;
									}
								}
							}
							return val;
						},
					},
					{ title: 'Additional Request', data: 'additionalRequest', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Action',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.HRSupport}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TimeSheet:
				baseOptions.columns = [
					{
						title: 'Pay Period',
						data: 'payPeriodName',
						bSortable: true,
					},
					{
						title: 'Total Hours',
						data: null,
						bSortable: false,
						mRender: (data) => {
							// Calculate total hours from the entries array
							return data.entries.reduce((acc, entry) => acc + entry.hours, 0);
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Action',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TimeSheet}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MonthlyTimeSheet:
				baseOptions.columns = [
					{ title: 'Year', data: 'year', bSortable: true },
					{
						title: 'Month',
						data: 'monthOfYear',
						bSortable: true,
						mRender: (data) => {
							// Map month number to month name
							const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return months[data - 1]; // Subtract 1 since monthOfYear starts from 1
						},
					},
					{
						title: 'Total Hours',
						data: null,
						bSortable: false,
						mRender: (data) => {
							// Calculate total hours and minutes from the entries array
							let totalHours = 0;
							let totalMinutes = 0;
							data.entries.forEach((entry) => {
								// Parse the total hours string (e.g., "10h 3m")
								const hoursMinutes = entry.totalHours.split(' ');
								const hours = parseInt(hoursMinutes[0], 10);
								const minutes = parseInt(hoursMinutes[1], 10);

								totalHours += hours;
								totalMinutes += minutes;
							});

							// Adjust total hours if minutes exceed 60
							totalHours += Math.floor(totalMinutes / 60);
							totalMinutes %= 60;

							// Construct the total hours and minutes string
							const totalHoursString = totalHours > 0 ? totalHours + ' hours' : '';
							const totalMinutesString = totalMinutes > 0 ? ' and ' + totalMinutes + ' minutes' : '';

							return totalHoursString + totalMinutesString;
						},
					},

					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Action',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MonthlyTimeSheet}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.InvoiceApproval:
				baseOptions.columns = [];
				if (this.userService.currentUserValue.user.clientId === 'cfb1b93d-8bf9-492a-bc9d-5817de48a3e2') {
					baseOptions.columns.push({
						title: 'Project Manager',
						data: 'projectManager',
						visible: false,
					});
					baseOptions.columns.push({
						title: 'Project #',
						data: 'projectNumber',
					});
					baseOptions.columns.push({
						title: 'Project Title',
						data: 'projectName',
					});
				}
				baseOptions.columns.push({
					title: 'Invoice Number',
					data: 'invoiceNumber',
					bSortable: true,
				});
				baseOptions.columns.push({ title: 'Vendor Name', data: 'vendorName' });
				baseOptions.columns.push({
					title: 'Invoice Amount',
					data: 'invoiceAmount',
					render: $.fn.dataTable.render.number(',', '.', 2, '$'),
				});
				baseOptions.columns.push({
					title: 'Status',
					data: null,
					bSortable: true,
					mRender: (data) => {
						return this.getFormDisplayStatus(data, dashboardData);
					},
				});
				baseOptions.columns.push({ title: 'Requested By', data: 'requestedBy', bSortable: true });
				baseOptions.columns.push({
					title: 'Created Date',
					data: 'createdDate',
					type: 'date',
					bSortable: true,
					mRender: (data) => {
						return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
					},
				});
				baseOptions.columns.push({
					title: 'Modified Date',
					data: 'completedDate',
					type: 'date',
					bSortable: true,
					mRender: (data) => {
						return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
					},
				});
				baseOptions.columns.push({
					title: '',
					data: null,
					bSortable: false,
					width: '100px',
					mRender: (data) => {
						return `<button  data-id="${data.id}" data-type="${FormOptions.InvoiceApproval}" class="btn btn-link view">View Form</button>`;
					},
				});
				break;
			case FormOptions.AclarianTask:
				baseOptions.columns = [
					{ title: 'Task Name', data: 'taskName' },
					{ title: 'Task Number', data: 'taskNumber' },
					{ title: 'Frequency', data: 'frequency' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.AclarianTask}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CCApproval:
				baseOptions.columns = [
					{ title: 'Card Holder', data: 'cardHolder' },
					{
						title: 'Statement End Date',
						data: 'statementEndDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CCApproval}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.VendorForm:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'name' },
					{ title: 'Legal Entity Names', data: 'legalName' },
					{
						title: 'Contact Name',
						data: null,
						mRender: (data: any) => {
							let val = '';
							if (data?.contacts?.length > 0) {
								for (const item of data.contacts) {
									if (item.contactName) {
										val += `${item.contactName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: null,
						bSortable: true,
						mRender: (data) => {
							let val = '';
							if (data?.requestedByEmails?.length > 0) {
								for (const item of data.requestedByEmails) {
									val += `${item}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Delegate Allowed?',
						data: 'isDelegateAllowed',
						bSortable: false,
						mRender: (data) => {
							return data ? 'Yes' : 'No';
						},
					},
					{
						title: 'Delegated By',
						data: 'delegatedByName',
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.VendorForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;

			case FormOptions.VendorInformationChangeRequestForm:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'name' },
					{ title: 'description', data: 'description' },
					{ title: 'vendorType', data: 'vendorType' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Delegate Allowed?',
						data: 'isDelegateAllowed',
						bSortable: false,
						mRender: (data) => {
							return data ? 'Yes' : 'No';
						},
					},
					{
						title: 'Delegated By',
						data: 'delegatedByName',
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.VendorInformationChangeRequestForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;

			case FormOptions.BidForm:
				baseOptions.columns = [
					{ title: 'Bid Name', data: 'bidName' },
					{ title: 'Bid Number', data: 'bidNumber' },
					{
						title: 'Department(S)',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.bidApplicableDepartments?.length > 0) {
								for (const item of data.bidApplicableDepartments) {
									if (item.departmentName) {
										val += `${item.departmentName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BidForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BusinessLicense:
				baseOptions.columns = [
					{ title: 'License #', data: 'referenceId' },
					{ title: 'Business Name', data: 'businessName' },
					{ title: 'Applicant Name', data: 'applicantName' },
					{ title: 'Business Type', data: 'feeScheduleName' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FieldWorkRequest}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NYRevenueBudget:
				baseOptions.columns = [
					{
						title: 'Fiscal Year',
						data: 'fiscalYear',
						bSortable: true,
					},
					{
						title: 'Fund',
						data: 'fund',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NYRevenueBudget}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NYCapitalBudget:
				baseOptions.columns = [
					{
						title: 'FISCAL YEAR',
						data: 'fiscalYear',
						bSortable: true,
					},
					{
						title: 'FUND',
						data: null,
						bSortable: false,
						mRender: (data: CapitalBudgetView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									if (item.fund) {
										val += `${item.fund ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'DEPARTMENT',
						data: 'department',
						bSortable: true,
					},
					{
						title: 'GL ACCOUNT',
						data: null,
						bSortable: false,
						mRender: (data: CapitalBudgetView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedger}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'STATUS',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'REQUESTED BY', data: 'requestedBy', bSortable: true },
					{
						title: 'CREATED DATE',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NYCapitalBudget}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CapitalAdditionForm:
				baseOptions.columns = [
					{
						title: 'Asset Addition Method',
						data: 'assetAdditionType',
						bSortable: true,
						mRender: (data) => {
							switch (data) {
								case AssetAdditionType.NewAsset:
									return 'New Asset';
								case AssetAdditionType.AdditionToExistingAsset:
									return 'Addition to Existing Asset';
								case AssetAdditionType.CipAssetConversion:
									return 'CIP Conversion';
								default:
									return '';
							}
						},
					},
					{ title: 'Asset Type', data: 'assetType', bSortable: true },
					{ title: 'Fund', data: 'fund', bSortable: true },
					{ title: 'Department', data: 'department', bSortable: true },
					{ title: 'Asset Description', data: 'description', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CapitalAdditionForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CapitalDisposalForm:
				baseOptions.columns = [
					{ title: 'Department', data: 'department', bSortable: true },
					{ title: 'Asset Number', data: 'assetNumber', bSortable: true },
					{
						title: 'Disposal Date',
						data: 'disposalDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CapitalDisposalForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CapitalTransferForm:
				baseOptions.columns = [
					{ title: 'Asset', data: 'assetName', bSortable: true },
					{ title: 'From Department', data: 'fromDepartment', bSortable: true },
					{ title: 'To Department', data: 'toDepartment', bSortable: true },
					{
						title: 'Transfer Date',
						data: 'transferDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CapitalTransferForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CapitalWorkOrderForm:
				baseOptions.columns = [
					{ title: 'Asset Number', data: 'assetNumber', bSortable: true },
					{ title: 'Name', data: 'assetName', bSortable: true },
					{ title: 'Work Order Type', data: 'assetWorkOrderType', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CapitalWorkOrderForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.JournalEntryForm:
				baseOptions.columns = [
					{ title: 'Entry Number', data: 'entryNumber', bSortable: true },
					{ title: 'Fiscal Year', data: 'effectiveYear', bSortable: true },
					{
						title: 'Fiscal Month',
						data: 'effectiveMonth',
						bSortable: true,
						mRender: (data) => {
							return data ? this.utilityService.getMonthNameFromNumber(data) : '';
						},
					},
					{
						title: 'Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data?.entries?.length > 0) {
								let totalAmount = 0;
								for (const item of data.entries) {
									totalAmount += item.debit ?? 0;
								}
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{ title: 'Short Description', data: 'shortDescription', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.JournalEntryForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DepartmentAdditionForm:
				baseOptions.columns = [
					{ title: 'Department ID', data: 'departmentId', bSortable: true },
					{ title: 'Name', data: 'name', bSortable: true },
					{ title: 'Function', data: 'functionIdName', bSortable: true },
					{ title: 'Sub-Function', data: 'subFunctionIdName', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DepartmentAdditionForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.FundAdditionForm:
				baseOptions.columns = [
					{ title: 'Fund Id', data: 'fundId', bSortable: true },
					{ title: 'Name', data: 'name', bSortable: true },
					{ title: 'Fund Type', data: 'fundTypeName', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FundAdditionForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ReceiptVerification:
				baseOptions.columns = [
					{
						title: 'Date',
						data: 'date',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Department', data: 'departmentName', bSortable: true },
					{
						title: 'Amount In Cash',
						data: 'amountReceivedinCash',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Amount In Checks',
						data: 'amountReceivedinCheques',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Amount In Credit Cards',
						data: 'amountReceivedinCreditCard',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ReceiptVerification}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CashieringReport:
				baseOptions.columns = [
					{ title: 'Created By', data: 'createdByUserame' },
					{ title: 'Entry Number', data: 'journalEntryNumber', visible: false },
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data?.cashieringEntries?.length > 0) {
								const totalAmount = data.cashieringEntries
									.filter((x) => x.amount)
									.map((x) => x.amount)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CashieringReport}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectManagement:
				baseOptions.columns = [
					{ title: 'Project Number', data: 'name' },
					{ title: 'Project Title', data: 'description' },
					{ title: 'Project Type', data: 'projectType' },
					{
						title: 'Project Amount',
						data: 'totalProjectAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},

					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectManagement}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.FundingIncreaseForm:
				baseOptions.columns = [
					{ title: 'Funding Type', data: 'fundType' },
					{ title: 'Project From', data: 'projectNameFrom' },
					{ title: 'Project To', data: 'projectNameTo' },
					{
						title: 'Fund Increase Amount',
						data: 'fundAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FundingIncreaseForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PaymentApprovalForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Vendor Name', data: 'vendorName' },
					{
						title: 'Project Name',
						data: null,
						mRender: (data) => {
							let val = '';
							if (data?.paymentApprovalProjects?.length > 0) {
								for (const item of data.paymentApprovalProjects) {
									if (item.name) {
										val += `${item.name ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Payment Amount',
						data: 'paymentAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},

					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PaymentApprovalForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectCloseForm:
				baseOptions.columns = [
					{ title: 'Project', data: 'name' },
					{ title: 'Project Number', data: 'projectNumber' },
					{
						title: 'Total Project Amount',
						data: 'totalProjectAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Remaining Balance',
						data: 'remainingBalance',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},

					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectCloseForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.LeaseEvaluation:
				baseOptions.order = [[3, 'desc']];
				baseOptions.columns = [
					{ title: 'Entity Name', data: 'entityName', bSortable: true },
					{ title: 'Contract Number & Title', data: 'contractNumberTitle', bSortable: true },
					{
						title: 'Begin Date',
						data: 'beginDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Assigned To', data: 'assignedTo', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.LeaseEvaluation}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PersonnelManagement:
				baseOptions.columns = [
					{ title: 'Fiscal Year', data: 'fiscalYear', bSortable: true },
					{ title: 'Department Number', data: 'departmentId', bSortable: true },
					{ title: 'Department', data: 'department', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PersonnelManagement}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ContractApproval:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendorName', bSortable: true },
					{
						title: 'Contract Start Date',
						data: 'contractStartDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Contract End Date',
						data: 'contractEndDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department(S)',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.contractLinkedDepartmentView?.length > 0) {
								for (const item of data.contractLinkedDepartmentView) {
									if (item.name) {
										val += `${item.name ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Contract Amount',
						data: 'contractAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ContractApproval}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.AccountCreation:
				baseOptions.columns = [
					{ title: 'Account Type', data: 'accountsTypeName', bSortable: true },
					{
						title: 'Fund',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data: any) => {
							if (data.formType === 'createAccount') {
								return data.fundIdName;
							} else {
								let val = '';
								if (data?.combinations?.length > 0) {
									for (const item of data.combinations) {
										if (item.fund) {
											val += `${item.fund ?? ''}<br />`;
										}
									}
								}
								return val;
							}
						},
					},
					{
						title: 'Department',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data: any) => {
							if (data.formType === 'createAccount') {
								return data.departmentName;
							} else {
								let val = '';
								if (data?.combinations?.length > 0) {
									for (const item of data.combinations) {
										if (item.department) {
											val += `${item.department ?? ''}<br />`;
										}
									}
								}
								return val;
							}
						},
					},
					{
						title: 'Gl Account',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data: any) => {
							if (data.formType === 'createAccount') {
								return data.accounts;
							} else {
								let val = '';
								if (data?.combinations?.length > 0) {
									for (const item of data.combinations) {
										if (item.accountCode) {
											val += `${item.accountCode ?? ''}<br />`;
										}
									}
								}
								return val;
							}
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.AccountCreation}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PoRolloverForm:
				baseOptions.columns = [
					{ title: 'PO Number', data: 'poNumber', bSortable: true },
					{ title: 'Vendor Name', data: 'vendor', bSortable: true },
					{
						title: 'Remaining Balance',
						data: 'balance',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{ title: 'Rollover To Fiscal Year', data: 'rolloverToFiscalYear', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PoRolloverForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PoRollbackForm:
				baseOptions.columns = [
					{
						title: 'PO Number',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.joinPoRollbackDetails(data, (detail) => detail.poNumber);
						},
					},
					{
						title: 'Vendor Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.joinPoRollbackDetails(data, (detail) => detail.vendor);
						},
					},
					{
						title: 'Remaining Balance',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.utilityService.formatCurrency(this.sumPoRollbackBalance(data));
						},
					},
					{
						title: 'Roll Back Fiscal Year',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.joinPoRollbackDetails(data, (detail) => detail.rollBackFiscalYear);
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PoRollbackForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectOpenForm:
				baseOptions.columns = [
					{ title: 'Project Name', data: 'name' },
					{ title: 'Project Number', data: 'projectNumber' },
					{
						title: 'Total Project Amount',
						data: 'totalProjectAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Remaining Balance',
						data: 'remainingBalance',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectOpenForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerInvoiceForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerForm.name', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Description', data: 'invoiceDescription', bSortable: false },
					{
						title: 'Total Due',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data.invoiceStatus?.includes('Carried Over To Invoice')) {
								return this.utilityService.formatCurrency(0);
							}
							return this.utilityService.formatCurrency(data.totalDue ?? 0);
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: false },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomerInvoiceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerForm:
				baseOptions.columns = [
					{ title: 'Customer name', data: 'name', bSortable: true },
					{
						title: 'contact Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data.contactName + ' ' + data.contactLastName;
						},
					},
					{ title: 'contact title', data: 'contactTitle', bSortable: true },
					{ title: 'contact phone', data: 'contactPhone', bSortable: true },
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'created date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomerForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.QuickInvoiceForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Description', data: 'invoiceDescription', bSortable: true },
					{
						title: 'Total Due',
						data: 'totalDue',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.QuickInvoiceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.QuickPayForm:
				baseOptions.columns = [
					{
						title: 'Invoice Number',
						data: 'invoiceNumber',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Vendor Name',
						data: 'vendor',
						bSortable: true,
					},
					{
						title: 'Description',
						data: 'description',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data && data.accounts.length > 0) {
								const totalAmount = data.accounts
									.filter((x) => x.amount)
									.map((x) => x.amount)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: null,
						bSortable: true,
						mRender: (data) => {
							let val = '';
							if (data?.requestedByEmails?.length > 0) {
								for (const item of data.requestedByEmails) {
									val += `${item}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.QuickPayForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BankReconciliation:
				baseOptions.columns = [
					{ title: 'Fiscal Year', data: 'year', bSortable: true },
					{ title: 'Fiscal Month', data: 'month', bSortable: true },
					{
						title: 'ENDING ADJUSTED GL BALANCE',
						data: 'adjustedGlBalance',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BankReconciliation}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.WorkOrderRequestForm:
				baseOptions.columns = [
					{ title: 'Category', data: 'category' },
					{ title: 'Description', data: 'requestDescription' },
					{ title: 'Priority', data: 'priority' },
					{
						title: 'Assign To',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data.workOrderAssignees && data.workOrderAssignees.length > 0) {
								return data.workOrderAssignees.map((department) => department.assignedToName).join(', ');
							} else {
								return '';
							}
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.WorkOrderRequestForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectGrantForm:
				baseOptions.columns = [
					{ title: 'Type', data: 'type', bSortable: true },
					{ title: 'Project/Grant Number', data: 'number', bSortable: true },
					{ title: 'Project/Grant Title', data: 'title', bSortable: true },
					{ title: 'Project/Grant Type', data: 'projectType', bSortable: true },
					{
						title: 'Total Estimated Amount',
						data: 'totalEstimatedAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectGrantForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectGrantTask:
				baseOptions.columns = [
					{ title: 'Task Number', data: 'number', bSortable: true },
					{ title: 'Title', data: 'title', bSortable: true },
					{ title: 'Type', data: 'type', bSortable: true },
					{
						title: 'Task Amount',
						data: 'totalEstimatedAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectGrantTask}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectGrantCloseForm:
				baseOptions.columns = [
					{
						title: 'PROJECT/GRANT NAME',
						data: null,
						bSortable: true,
						width: '200px',
						mRender: (data) => {
							return data.projectGrantForm?.number + ' - ' + data.projectGrantForm?.title;
						},
					},
					{
						title: 'CLOSING DATE',
						data: 'closingDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'CLOSING REASON',
						data: 'closingReason',
						bSortable: true,
						width: '200px',
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectGrantCloseForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProjectGrantReopenForm:
				baseOptions.columns = [
					{
						title: 'Project/Grant Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data.projectGrantForm.number + ' - ' + data.projectGrantForm.title;
						},
					},
					{ title: 'Reopen Project/Grant/Task', data: 'needToReopenProjectGrantTaskType', bSortable: true },
					{
						title: 'Reopen Date',
						data: 'reOpenDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Reopen Reason', data: 'reOpenReason', bSortable: true },
					{
						title: 'Remaining Amount',
						data: 'remainingEstimatedAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectGrantReopenForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OpenClosePeriod:
				baseOptions.columns = [
					{ title: 'Action', data: 'type', bSortable: true },
					{
						title: 'Period',
						data: null,
						mRender: (data: OpenClosePeriodFormView) => {
							let val = '';
							if (data?.openClosePeriodMonths?.length > 0) {
								for (const item of data.openClosePeriodMonths) {
									val += `${item.year}<br />`;
								}
							}
							return val;
						},
						bSortable: true,
					},
					{
						title: 'Month',
						data: null,
						mRender: (data: OpenClosePeriodFormView) => {
							let val = '';
							if (data?.openClosePeriodMonths?.length > 0) {
								for (const item of data.openClosePeriodMonths) {
									val += `${item.month}<br />`;
								}
							}
							return val;
						},
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OpenClosePeriod}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.JobApplication:
				baseOptions.columns = [
					{ title: 'Position Title', data: 'positionTitle', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.JobApplication}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.EmployeeActionForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.EmployeeActionForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.VoidReissueForm:
				baseOptions.columns = [
					{ title: 'Action', data: 'action' },
					{ title: 'Vendor Name', data: 'payeeName' },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Old Check Number', data: 'checkNo' },
					{ title: 'New Check Number', data: 'newCheckNo' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.VoidReissueForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PaymentAdjustmentForm:
				baseOptions.columns = [
					{ title: 'Source', data: 'source' },
					{ title: 'Payee Name', data: 'payeeName' },
					{ title: 'Check Number', data: 'checkNo' },
					{
						title: 'Original Amount',
						data: 'originalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Adjusted Amount',
						data: 'adjustedAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.PaymentAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TimeOff:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TimeOff}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.HrisTimeSheet:
				baseOptions.columns = [
					{
						title: 'Pay Period',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data
								? moment(data.startDate).format('MM/DD/YYYY') + ' - ' + moment(data.endDate).format('MM/DD/YYYY')
								: '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.HrisTimeSheet}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PerformanceEvaluation:
				baseOptions.columns = [
					{ title: 'Assigned To', data: 'assignedTo', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PerformanceEvaluation}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BenefitEnrolmentForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BenefitEnrolmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CashReceiptForm:
				baseOptions.columns = [
					{ title: 'Reference Id', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{ title: 'Payment Mode', data: 'paymentMode', bSortable: true },
					{ title: 'Check Number', data: 'checkNo', bSortable: true },
					{
						title: 'Total Amount',
						data: 'total',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CashReceiptForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CreditCardReport:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CreditCardReport}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.IndividualPayeeForm:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'name' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.IndividualPayeeForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.IndividualPaymentForm:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'payeeName' },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Description', data: 'description' },
					{
						title: 'Total Amount',
						data: 'amount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.IndividualPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DepreciationScheduleForm:
				baseOptions.columns = [
					{ title: 'AVAILABLE FISCAL YEAR', data: 'period', bSortable: true },
					{
						title: 'AVAILABLE MONTH',
						data: 'month',
						bSortable: true,
						mRender: (data) => {
							const monthNames = [
								'Jan',
								'Feb',
								'March',
								'April',
								'May',
								'June',
								'July',
								'Aug',
								'Sep',
								'Oct',
								'Nov',
								'Dec',
							];
							return monthNames[data - 1];
						},
					},
					{ title: 'DEPRECIATION METHOD', data: 'method', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DepreciationScheduleForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewDebtIssuanceForm:
				baseOptions.columns = [
					{ title: 'DEBT ISSUANCE NAME', data: 'debtIssuanceName', bSortable: true },
					{ title: 'REPAYMENT TYPE', data: 'debtRepaymentType', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewDebtIssuanceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DebtServicePaymentForm:
				baseOptions.columns = [
					{ title: 'DEBT ISSUANCE', data: 'debtIssuanceName', bSortable: true },
					{
						title: 'PAYMENT DUE DATE',
						data: 'paymentDueDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'SCHEDULED PAYMENT',
						data: 'scheduledPayment',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DebtServicePaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DebtCovenantComplianceForm:
				baseOptions.columns = [
					{ title: 'COMPLIANCE TASK NAME', data: 'name', bSortable: true },
					{ title: 'FREQUENCY', data: 'frequency', bSortable: true },
					{
						title: 'DUE DATE',
						data: 'dueDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DebtCovenantComplianceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DebtInvestmentJournalEntryForm:
				baseOptions.columns = [
					{ title: 'DEBT OR INVESTMENT JE', data: 'journalEntryCategory', bSortable: true },
					{ title: 'JE TYPE', data: 'journalEntryType', bSortable: true },
					{ title: 'FISCAL YEAR', data: 'fiscalYear', bSortable: true },
					{
						title: 'MONTH',
						data: 'month',
						bSortable: true,
						mRender: (data) => {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return monthNames[data - 1] ?? '';
						},
					},
					{
						title: 'EFFECTIVE DATE',
						data: 'effectiveDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DebtInvestmentJournalEntryForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.InvestmentSecurityPurchaseForm:
				baseOptions.columns = [
					{ title: 'CUSIP/ID', data: 'cusip', bSortable: true },
					{ title: 'INVESTMENT DESCRIPTION', data: 'investmentDescription', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.InvestmentSecurityPurchaseForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.UsageForm:
				baseOptions.columns = [
					{
						title: 'Fiscal Year',
						data: 'fiscalYear',
					},
					{ title: 'Month', data: 'month' },
					{
						title: 'Item Name',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.usageFormDetails?.length > 0) {
								for (const detail of data.usageFormDetails) {
									if (detail.item) {
										val += `${detail.item ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Location Name',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.usageFormDetails?.length > 0) {
								for (const detail of data.usageFormDetails) {
									if (detail.location) {
										val += `${detail.location ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Available Quantity',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.usageFormDetails?.length > 0) {
								for (const detail of data.usageFormDetails) {
									if (detail.availableQuantity) {
										val += `${detail.availableQuantity ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Quantity Used',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.usageFormDetails?.length > 0) {
								for (const detail of data.usageFormDetails) {
									if (detail.usedQuantity) {
										val += `${detail.usedQuantity ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.UsageForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerRefundForm:
				baseOptions.columns = [
					{
						title: 'Refund For',
						data: 'refundModule',
						bSortable: true,
						mRender: (data) => {
							return data === 'BL' ? 'Business License' : 'Billing AR';
						},
					},
					{ title: 'Customer/Business', data: 'business', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Refund Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data && data.accounts.length > 0) {
								const totalAmount = data.accounts
									.filter((x) => x.amount)
									.map((x) => x.amount)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomerRefundForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewCapitalLeaseForm:
				baseOptions.columns = [
					{ title: 'Lease Type', data: 'leaseType', bSortable: true },
					{ title: 'Asset Type', data: 'assetType', bSortable: true },
					{ title: 'Contract Number & Title', data: 'contractNumberAndTitle', bSortable: true },
					{
						title: 'Lease Commencement Date',
						data: 'leaseCommencementDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Payment Amount',
						data: null,
						bSortable: false,
						mRender: function (data) {
							if (data.capitalLeaseFormPayments && data.capitalLeaseFormPayments.length > 0) {
								const firstPaymentAmount = '$' + data.capitalLeaseFormPayments[0].paymentAmount.toFixed(2);
								return firstPaymentAmount;
							} else {
								return '';
							}
						},
					},
					{
						title: 'Annual Interest Rate',
						data: null,
						bSortable: false,
						mRender: function (data: any) {
							if (data.capitalLeaseFormPayments && data.capitalLeaseFormPayments.length > 0) {
								return data.capitalLeaseFormPayments[0].interestRate;
							} else {
								return '';
							}
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data: any) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewCapitalLeaseForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.UtilityApplication:
				baseOptions.columns = [
					{
						title: 'Primary Name',
						data: null,
						mRender: (data) => {
							return data ? data.primaryFirstName + ' ' + data.primaryMiddleName + ' ' + data.primaryLastName : '';
						},
					},
					{ title: 'Confirmation #', data: 'confirmationNumber' },
					{
						title: 'SSN(Residential)',
						data: 'ssnResidential',
						mRender: (data) => {
							return data ? data : 'N/A';
						},
					},
					{
						title: 'EIN(Business)',
						data: 'businessEin',
						mRender: (data) => {
							return data ? data : 'N/A';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.UtilityApplication}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CreateInvoiceForm:
				baseOptions.columns = [
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CreateInvoiceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.LeaseModificationForm:
				baseOptions.columns = [
					{ title: 'Fiscal Year', data: 'fiscalYear', bSortable: true },
					{
						title: 'Month',
						data: null,
						bSortable: true,
						mRender: function (data) {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return monthNames[data.applicableMonth - 1];
						},
					},
					{ title: 'Lease Modification Type', data: 'modificationType', bSortable: true },
					{ title: 'Lease Type', data: 'leaseType', bSortable: true },
					{ title: 'Existing Lease', data: 'existingLease', bSortable: true },
					{
						title: 'Month',
						data: null,
						bSortable: true,
						mRender: function (data) {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return monthNames[data.applicableMonth - 1];
						},
					},
					{ title: 'Lease Modification Type', data: 'modificationType', bSortable: true },
					{ title: 'Lease Type', data: 'leaseType', bSortable: true },
					{ title: 'Existing Lease', data: 'existingLease', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.LeaseModificationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.Implementation:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.Implementation}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ImplementationGL:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ImplementationGL}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewHireForm:
				baseOptions.columns = [
					{
						title: 'Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data.firstName + ' ' + (data.middleName || '') + ' ' + (data.lastName || '');
						},
					},
					{ title: 'Primary Phone', data: 'primaryPhone', bSortable: true },
					{ title: 'Email', data: 'email', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewHireForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ImplementationPurchasing:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ImplementationPurchasing}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.LeaveBalanceAdjustmentForm:
				baseOptions.columns = [
					{ title: 'Employee Code', data: 'employeeCode', bSortable: true },
					{ title: 'Employee Name', data: 'employeeName', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.LeaveBalanceAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ImplementationPayment:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ImplementationPayment}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.UserWorkflowForm:
				baseOptions.columns = [
					{
						title: 'User Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data ? data.firstName + ' ' + data.lastName : '';
						},
					},
					{ title: 'Title', data: 'title', bSortable: true },
					{
						title: 'Client(s)',
						data: null,
						bSortable: true,
						mRender: (data) => {
							const clients = data.clientAssignments.map((x) => {
								return `${x.clientName}`;
							});
							return clients.join(', ');
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.UserWorkflowForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.WorkflowGroup:
				baseOptions.columns = [
					{
						title: 'Group Type',
						data: null,
						bSortable: true,
						mRender: (data) => {
							switch (data.workflowType) {
								case 0:
									return 'User Approval';
								case 1:
									return 'Threshold Approval';
								case 2:
									return 'Entity And Organization Approval';
								case 3:
									return 'Project/Grant Approval';
								case 4:
									return 'Vendor Approval';
								case 5:
									return 'PO Number Approval';
								default:
									return '';
							}
						},
					},
					{
						title: 'Group Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Numer of Approvals',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data.totalRequiredApprovals === -1) {
								return 'All';
							} else {
								return data.totalRequiredApprovals;
							}
						},
					},
					{
						title: 'Threshold Value',
						data: 'thresholdValue',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.WorkflowGroup}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TimeSheetApprovalForm:
				baseOptions.columns = [
					{
						title: 'Fiscal Year',
						data: 'fiscalYear',
						bSortable: true,
					},
					{
						title: 'Pay Period',
						data: null,
						bSortable: true,
						mRender: (data) => {
							const startDate = moment(data.startDate).format('MM/DD/YYYY');
							const endDate = moment(data.endDate).format('MM/DD/YYYY');
							return `${data.payPeriod} (${startDate} - ${endDate})`;
						},
					},
					{
						title: 'Employee Name',
						data: 'employeeName',
						bSortable: true,
					},
					{
						title: 'Total Hours',
						data: 'totalHours',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TimeSheetApprovalForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerInvoiceAdjustmentForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{ title: 'Description', data: 'description', bSortable: true },
					{
						title: 'Revised Invoiced Amount',
						data: 'revisedTotalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomerInvoiceAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ImplementationHR:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ImplementationHR}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CapitalReclassification:
				baseOptions.columns = [
					{
						title: 'Fiscal Year',
						data: 'fiscalYear',
						bSortable: true,
					},
					{
						title: 'Credit Account',
						data: 'creditAccount',
						bSortable: true,
					},
					{
						title: 'Debit Account',
						data: null,
						mRender: (data: ReclassificationForm) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedgerId}<br />`;
								}
							}
							return val;
						},
						bSortable: true,
					},
					{
						title: 'Reclassified Amount',
						data: 'reclassifiedAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CapitalReclassification}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TravelPreApprovalForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'employeeName',
						bSortable: true,
					},
					{
						title: 'Purpose Of Trip',
						data: 'purposeOfTrip',
						bSortable: true,
					},
					{
						title: 'Start Date',
						data: 'startDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'End Date',
						data: 'endDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TravelPreApprovalForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TravelReimbursementForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'employeeName',
						bSortable: true,
					},
					{
						title: 'Department(s)',
						data: null,
						bSortable: true,
						mRender: (data) => {
							let val = '';
							if (data?.travelApplicableDepartments?.length > 0) {
								for (const item of data.travelApplicableDepartments) {
									if (item.departmentName) {
										val += `${item.departmentName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TravelReimbursementForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TravelReimbursementPaymentForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'employeeName',
						bSortable: true,
					},
					{
						title: 'Purpose Of Trip',
						data: 'purposeOfTrip',
						bSortable: true,
					},
					{
						title: 'Account String',
						data: 'account',
						bSortable: true,
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TravelReimbursementPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ElectronicAchReport:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ElectronicAchReport}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ComplainantForm:
				baseOptions.columns = [
					{ title: 'CASE NUMBER', data: 'referenceId', bSortable: true },
					{ title: 'COMPLAINT TYPE', data: 'complaintTypeName', bSortable: true },
					{ title: 'PROPERTY ADDRESS', data: 'propertyAddress', bSortable: true },
					{ title: 'PROPERTY CITY', data: 'propertyCity', bSortable: true },
					{ title: 'PROPERTY STATE', data: 'propertyState', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'REQUESTED BY', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ComplainantForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.RequestForm:
				baseOptions.columns = [
					{ title: 'Task Name', data: 'taskName' },
					{ title: 'Frequency', data: 'frequency' },
					{ title: 'Assign To', data: 'assignedToUserName' },
					{ title: 'Due Date', data: 'dueDate' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.RequestForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PurchasingEmployee:
				baseOptions.columns = [
					{
						title: 'Employee Id',
						data: 'empId',
						bSortable: true,
					},
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Department',
						data: 'departmentName',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PurchasingEmployee}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TaxingJurisdiction:
				baseOptions.columns = [
					{
						title: 'Aclarian Vendor ID',
						data: 'aclarianVendorID',
						bSortable: true,
					},
					{
						title: 'Aclarian Vendor Name',
						data: 'aclarianVendorName',
						bSortable: true,
					},
					{
						title: 'Contact Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data ? data.contactFirstName + ' ' + data.contactLastName : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TaxingJurisdiction}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TuitionReimbursementForm:
				baseOptions.columns = [
					{ title: 'Employee Name', data: 'employeeName', bSortable: true },
					{ title: 'Job Title', data: 'jobTitle', bSortable: true },
					{ title: 'Department', data: 'departmentName', bSortable: true },
					{
						title: 'Class Begin Date',
						data: 'classBegins',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Class End Date',
						data: 'classEnds',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TuitionReimbursementForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TuitionReimbursementPaymentForm:
				baseOptions.columns = [
					{ title: 'Employee Name', data: 'employeeName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Tuition Fee',
						data: 'totalTuitionFee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Book Costs',
						data: 'totalBooksFee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Total Amount',
						data: 'totalDueEmployee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TuitionReimbursementPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TaxDistributionForm:
				baseOptions.columns = [
					{ title: 'Name', data: 'name', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TaxDistributionForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.Announcements:
				baseOptions.columns = [
					{ title: 'Title', data: 'title', bSortable: true },
					{ title: 'Message', data: 'message', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},

					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.Announcements}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OtherReimbursableExpensesForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department',
						data: 'department',
						bSortable: true,
					},
					{
						title: 'Total Reimbursement',
						data: 'totalReimbursementAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OtherReimbursableExpensesForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.LocalVicinityTravelForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department',
						data: 'departmentName',
						bSortable: true,
					},
					{
						title: 'Purpose Of Trip',
						data: null,
						bSortable: false,
						mRender: (data) => {
							let val = '';
							if (data?.localVicinityTravel?.length > 0) {
								for (const item of data.localVicinityTravel) {
									if (item.purposeOfTrip) {
										val += `${item.purposeOfTrip}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Total Reimbursement',
						data: 'totalReimbursementAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.LocalVicinityTravelForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OutofCountyTravelForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department',
						data: 'department',
						bSortable: true,
					},
					{
						title: 'Purpose Of Trip',
						data: 'purposeOfTravel',
						bSortable: true,
					},
					{
						title: 'Total Reimbursement',
						data: 'totalReimbursementToEmployee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OutofCountyTravelForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.FiservRefundForm:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'payeeName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Refund Type', data: 'typeOfRefund', bSortable: true },
					{
						title: 'Refund Amount',
						data: 'refundAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FiservRefundForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.SpecialPayForm:
				baseOptions.columns = [
					{ title: 'Payroll Type', data: 'payrollTypes', bSortable: true },
					{
						title: 'Action',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data.actionType === 0) {
								return '';
							} else if (data.actionType === 1) {
								return 'SupplementalWage';
							} else if (data.actionType === 2) {
								return 'FinalPay';
							} else {
								return '';
							}
						},
					},
					{
						title: 'Effective Date',
						data: 'effectiveDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.SpecialPayForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TuitionReimbPreApprovalForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Department',
						data: 'departmentName',
						bSortable: true,
					},
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TuitionReimbPreApprovalForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.InvestmentIncomeAllocationForm:
				baseOptions.columns = [
					{
						title: 'Fiscal Year Start',
						data: 'fiscalYearStart',
						bSortable: true,
					},
					{
						title: 'Fiscal Month Start',
						data: 'fiscalMonthStart',
						bSortable: true,
						mRender: function (data) {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return monthNames[data - 1];
						},
					},
					{
						title: 'Fiscal Year End',
						data: 'fiscalYearEnd',
						bSortable: true,
					},
					{
						title: 'Fiscal Month End',
						data: 'fiscalMonthEnd',
						bSortable: true,
						mRender: function (data) {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return monthNames[data - 1];
						},
					},
					{
						title: 'Amount To Allocate',
						data: 'amountToAllocate',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.InvestmentIncomeAllocationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.IndividualRefundForm:
				baseOptions.columns = [
					{
						title: 'Payee Name',
						data: null,
						bSortable: false,
						mRender: (data: IndividualRefundView) => {
							let val = '';
							if (data?.individualRefundFormDetail?.length > 0) {
								for (const item of data.individualRefundFormDetail) {
									if (item.payeeName) {
										val += `${item.payeeName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Refund Type',
						data: null,
						bSortable: false,
						mRender: (data: IndividualRefundView) => {
							let val = '';
							if (data?.individualRefundFormDetail?.length > 0) {
								for (const item of data.individualRefundFormDetail) {
									if (item.typeOfRefund) {
										val += `${item.typeOfRefund ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Refund Amount',
						data: null,
						bSortable: false,
						mRender: (data: IndividualRefundView) => {
							let val = '';
							if (data?.individualRefundFormDetail?.length > 0) {
								for (const item of data.individualRefundFormDetail) {
									if (item.refundAmount) {
										val += `${this.utilityService.formatCurrency(item.refundAmount) ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.IndividualRefundForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TaxCertificateRedemptionCheckForm:
				baseOptions.columns = [
					{
						title: 'Invoice Number',
						data: null,
						bSortable: false,
						mRender: (data: TaxCertificateRedemptionCheckView) => {
							let val = '';
							if (data?.taxCertificateRedemptionCheckFormDetailView?.length > 0) {
								for (const item of data.taxCertificateRedemptionCheckFormDetailView) {
									if (item.taxRedemptionInvoiceNumber) {
										val += `${item.taxRedemptionInvoiceNumber ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Payee Name',
						data: null,
						bSortable: false,
						mRender: (data: TaxCertificateRedemptionCheckView) => {
							let val = '';
							if (data?.taxCertificateRedemptionCheckFormDetailView?.length > 0) {
								for (const item of data.taxCertificateRedemptionCheckFormDetailView) {
									if (item.payeeName) {
										val += `${item.payeeName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: 'grandTotal',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TaxCertificateRedemptionCheckForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TaxCertificateRedemptionACHForm:
				baseOptions.columns = [
					{
						title: 'Refund Batch Number',
						data: 'refundBatchNumber',
						bSortable: true,
					},
					{
						title: 'Refunding To',
						data: 'refundingToName',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Amount',
						data: 'amount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TaxCertificateRedemptionACHForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.GoLiveApprovalForm:
				baseOptions.columns = [
					{
						title: 'Module Name',
						data: 'moduleName',
						bSortable: true,
					},
					{
						title: 'Requested Go Live Date',
						data: 'requestedGoLiveDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Go Live Instructions',
						data: 'goLiveInstructions',
						bSortable: true,
					},
					{
						title: 'Additional Comments',
						data: 'additionalComments',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.GoLiveApprovalForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TrainingCertificationForm:
				baseOptions.columns = [
					{
						title: 'Module Name',
						data: 'moduleName',
						bSortable: true,
					},
					{
						title: 'Due Date',
						data: 'dueDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Assignment Description',
						data: 'description',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TrainingCertificationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.LocationForm:
				baseOptions.columns = [
					{
						title: 'Location Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Address',
						data: 'addressLine1',
						bSortable: true,
					},
					{
						title: 'City',
						data: 'city',
						bSortable: true,
					},
					{
						title: 'State',
						data: 'state',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.LocationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ItemForm:
				baseOptions.columns = [
					{
						title: 'Item Code',
						data: 'itemCode',
						bSortable: true,
					},
					{
						title: 'Item Name',
						data: 'itemName',
						bSortable: true,
					},
					{
						title: 'Item Category',
						data: 'itemCategoryName',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ItemForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ReceivingForm:
				baseOptions.columns = [
					{
						title: 'Vendor',
						data: 'vendor',
						bSortable: true,
					},
					{
						title: 'Location',
						data: 'location',
						bSortable: true,
					},
					{
						title: 'Date Items Received',
						data: 'dateItemsReceived',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ReceivingForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewCustomerForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},

					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewCustomerForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewPropertyForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},

					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewPropertyForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewCustomerAccountForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewCustomerAccountForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.FeeAdjustmentForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FeeAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.UsageAdjustmentForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},

					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.UsageAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ManualMeterReadForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ManualMeterReadForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MeterTurnOnForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},

					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MeterTurnOnForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MeterTurnOffForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MeterTurnOffForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MassPayRateChangeForm:
				baseOptions.columns = [
					{
						title: 'Fiscal Year',
						data: 'fiscalYear',
						bSortable: true,
					},
					{
						title: 'Payroll Type',
						data: 'payrollTypeName',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MassPayRateChangeForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.AdjustmentForm:
				baseOptions.columns = [
					// EN-4353: a form now covers many items, so the list shows a summary of their names
					// and how many there are rather than one item's quantity.
					{ title: 'Items', data: 'itemName', bSortable: true },
					{ title: 'Adjustment Type', data: 'adjustmentTypeName', bSortable: true },
					{ title: 'New Location', data: 'transferredLocationName', bSortable: true },
					{ title: 'Item Count', data: 'itemCount', bSortable: true },
					{
						title: 'Effective Date',
						data: 'effectiveDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.AdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CashBondForm:
				baseOptions.columns = [
					{ title: 'Bond Number', data: 'bondNumber', bSortable: true },
					{ title: 'Depositor Name', data: 'depositorName', bSortable: true },
					{ title: 'Defendant Name', data: 'defendantName', bSortable: true },
					{
						title: 'Bond Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return `$${data.bondAmount}`;
						},
					},
					{
						title: 'Date Received',
						data: 'dateReceived',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CashBondForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ImplementationPayroll:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ImplementationPayroll}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.JuryCheckRegistryForm:
				baseOptions.columns = [
					{
						title: 'JUROR NAME',
						data: null,
						bSortable: false,
						mRender: (data) => {
							let val = '';
							if (data?.juryCheckRegistryFormDetail?.length > 0) {
								for (const item of data.juryCheckRegistryFormDetail) {
									if (item.juryFirstName) {
										val += `${(item.juryFirstName ?? '') + ' ' + (item.juryLastName ?? '')}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Check Amount',
						data: null,
						bSortable: false,
						mRender: (data) => {
							let val = '';
							if (data?.juryCheckRegistryFormDetail?.length > 0) {
								for (const item of data.juryCheckRegistryFormDetail) {
									if (item.checkAmount) {
										val += `${this.utilityService.formatCurrency(item.checkAmount)}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},

					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.JuryCheckRegistryForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.TransactionAssignmentForm:
				baseOptions.columns = [
					{ title: 'Source Type', data: 'source', bSortable: true },
					{ title: 'Form Link Url', data: 'formURL', bSortable: true },
					{ title: 'Reason For Change', data: 'description', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.TransactionAssignmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.LeaveBalancePayoutForm:
				baseOptions.columns = [
					{
						title: 'Leave Type',
						data: 'leaveTypeName',
						bSortable: true,
					},
					{
						title: 'Payroll Type',
						data: 'payrollTypeName',
						bSortable: true,
					},
					{
						title: 'Effective Date',
						data: 'effectiveDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.LeaveBalancePayoutForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PaymentPlanForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PaymentPlanForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MeterChangeOutForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MeterChangeOutForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PayrollAdjustmentForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'employeeName',
					},
					{
						title: 'Pay Period',
						data: null,
						bSortable: false,
						mRender: (data) => {
							const payPeriods = data.payrollAdjustmentEmployees.map((employee) => {
								const startDate = moment(employee.payPeriodStartDate).format('MM/DD/YYYY');
								const endDate = moment(employee.payPeriodEndDate).format('MM/DD/YYYY');
								return `${employee.payPeriod} (${startDate} - ${endDate})`;
							});
							return payPeriods.join(', ');
						},
					},

					{
						title: 'Adjustment',
						data: 'adjustment',
					},
					{
						title: 'Adjustment Type',
						data: 'adjustmentType',
					},
					{
						title: 'Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							const payPeriods = data.payrollAdjustmentEmployees.map((x) => {
								return `${'$' + x.amount}`;
							});
							return payPeriods.join(', ');
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PayrollAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OtherBankReconciliation:
				baseOptions.columns = [
					{ title: 'Fiscal Year', data: 'year', bSortable: true },
					{ title: 'Fiscal Month', data: 'month', bSortable: true },
					{
						title: 'ENDING ADJUSTED GL BALANCE',
						data: 'adjustedGlBalance',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OtherBankReconciliation}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MultiplePayment:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'payeeName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Batch Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Description', data: 'description', bSortable: true },
					{
						title: 'Total Amount',
						data: 'totalAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MultiplePayment}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerCreditMemo:
				baseOptions.columns = [
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{
						title: 'Credit Memo Date',
						data: 'creditMemoDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Short Description', data: 'shortDescription', bSortable: true },
					{
						title: 'Total',
						data: 'total',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomerCreditMemo}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.VendorCreditMemo:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendorName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Credit Memo Date',
						data: 'creditMemoDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{ title: 'Short Description', data: 'shortDescription', bSortable: true },
					{ title: 'Additional Details', data: 'additionalDetails', bSortable: true },
					{ title: 'Total', data: 'total', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.VendorCreditMemo}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.FieldRequestPaymentForm:
				baseOptions.columns = [
					{ title: 'Field Purchase Order Request Number', data: 'fieldPaymentRequestNumber', bSortable: true },
					{ title: 'Vendor Name', data: 'vendorName', bSortable: true },
					{ title: 'Short Description', data: 'shortDescription', bSortable: true },
					{ title: 'Amount', data: 'amount', bSortable: true, render: $.fn.dataTable.render.number(',', '.', 2, '$') },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.FieldRequestPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MultipleVendorPayment:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendorName', defaultContent: '', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						defaultContent: '',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Invoice Number', data: 'invoiceNumber', defaultContent: '', bSortable: true },
					{ title: 'Description', data: 'description', defaultContent: '', bSortable: true },
					{
						title: 'Amount',
						data: 'totalPaymentAmount',
						defaultContent: '$0.00',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', defaultContent: '', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						defaultContent: '',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.multipleVendorPaymentId}" data-type="${FormOptions.MultipleVendorPayment}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OtherTuitionReimbursementForm:
				baseOptions.columns = [
					{ title: 'Employee Name', data: 'employeeName', bSortable: true },
					{ title: 'Job Title', data: 'jobTitle', bSortable: true },
					{
						title: 'Total Amount',
						data: 'totalTuition',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OtherTuitionReimbursementForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OtherTuitionReimbursementPaymentForm:
				baseOptions.columns = [
					{ title: 'Employee Name', data: 'employeeName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Tuition Fee',
						data: 'totalTuitionFee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Total Amount',
						data: 'totalDueEmployee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OtherTuitionReimbursementPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CashBondPaymentForm:
				baseOptions.columns = [
					{ title: 'Bond Number', data: 'bondNumber', bSortable: true },
					{ title: 'Depositor Name', data: 'depositorName', bSortable: true },
					{ title: 'Defendant Name', data: 'defendantName', bSortable: true },
					{
						title: 'Disbursed Date',
						data: 'disbursedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CashBondPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NYOperatingExpenseBudget:
				baseOptions.columns = [
					{ title: 'Fiscal Year', data: 'fiscalYear', bSortable: true },
					{ title: 'Department', data: 'department', bSortable: true },
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NYOperatingExpenseBudget}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.RestitutionPaymentForm:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'payeeName', bSortable: true },
					{
						title: 'Invoice Date',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data.invoiceDate).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Payment Amount',
						data: 'paymentAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) {
								return '';
							}
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.restitutionPaymentFormId}" data-type="${FormOptions.RestitutionPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];

				break;
			case FormOptions.CustomerFeedbackSurveyForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) {
								return '';
							}
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomerFeedbackSurveyForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.SpecialPayment:
				baseOptions.columns = [
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.SpecialPayment}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.InitialPurchaseRequestForm:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendor', bSortable: true },
					{
						title: 'Total Estimated Contract Value',
						data: 'totalContractValue',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) {
								return '';
							}
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.InitialPurchaseRequestForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BulkCashReceiptForm:
				baseOptions.columns = [
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							const totalAmount = data.bulkCashReceiptFormDetails.reduce((acc, item) => {
								if (!item.isDeleted) {
									acc += Number(item.total) || 0;
								}
								return acc;
							}, 0);
							return totalAmount ? `$${totalAmount.toFixed(2)}` : '$0.00';
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BulkCashReceiptForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.DailyFeesImportForm:
				baseOptions.columns = [
					{ title: 'Entry Number', data: 'journalEntryNumber', visible: false },
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data?.feeEntries && data.feeEntries.length > 0) {
								const totalAmount = data.feeEntries
									.filter((x) => x.credit)
									.map((x) => x.credit)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.DailyFeesImportForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.EmployeeReimbursableExpensesForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Reimbursement Type',
						data: 'reimbursementType',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Total Reimbursement',
						data: 'totalReimbursementAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.EmployeeReimbursableExpensesForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ContractAmendment:
				baseOptions.columns = [
					{ title: 'Contract Id', data: 'contractId', bSortable: true },
					{
						title: 'Amendment Number',
						data: null,
						mRender: (data) => {
							return data.amendmentId;
						},
						bSortable: true,
					},
					{ title: 'Name', data: 'name', bSortable: true },
					{
						title: 'Extension Start date',
						data: 'extensionStartDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Extension End date',
						data: 'extensionEndDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ContractAmendment}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CashieringAdjustmentForm:
				baseOptions.columns = [
					{
						title: 'Source',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data.source === 'CashReceiptForm') {
								return 'Cash Receipt Form';
							} else if (data.source === 'CashBondReceiptForm') {
								return 'Cash Bond Receipt Form';
							} else if (data.source === 'MiscellaneousBilling') {
								return 'Customer Invoice Form';
							} else if (data.source === 'MiscellaneousBillingQuick') {
								return 'Quick Invoice Form';
							} else {
								return data.source;
							}
						},
					},
					{
						title: 'Form link',
						data: 'formURL',
						bSortable: true,
						width: '200px',
						render: function (data) {
							return `<a href="${data}" target="_blank" style="color: blue; text-decoration: underline;">Source Link</a>`;
						},
					},
					{ title: 'Reason for change', data: 'description', bSortable: true, width: '200px' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) {
								return '';
							}
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CashieringAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CashieringCloseoutReport:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CashieringCloseoutReport}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ParentVendorForm:
				baseOptions.columns = [
					{ title: 'Parent Vendor Name', data: 'name' },
					{
						title: 'Vendor Name',
						data: null,
						mRender: (data: any) => {
							if (data?.associatedVendors?.length > 0) {
								const names = data?.associatedVendors
									?.filter((item: any) => item?.vendor?.name)
									.map((item: any) => item.vendor.name);
								return names.join(',<br />');
							}
							return '';
						},
					},
					{
						title: 'Contact Name',
						data: null,
						mRender: (data: any) => {
							let val = '';
							if (data?.parentVendorContacts?.length > 0) {
								for (const item of data.parentVendorContacts) {
									if (item.contactName) {
										val += `${item.contactName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ParentVendorForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.NewHireRequestForm:
				baseOptions.columns = [
					{ title: 'Reason', data: 'reason', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.NewHireRequestForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.PolicyForm:
				baseOptions.columns = [
					{ title: 'Policy Name', data: 'name', bSortable: true },
					{ title: 'Policy Number', data: 'number', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.PolicyForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ProcedureForm:
				baseOptions.columns = [
					{ title: 'Procedure Name', data: 'name', bSortable: true },
					{ title: 'Procedure Number', data: 'number', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProcedureForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.OutofCountyTravelAdjustmentForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department',
						data: 'department',
						bSortable: true,
					},
					{
						title: 'Purpose Of Trip',
						data: 'purposeOfTravel',
						bSortable: true,
					},
					{
						title: 'Total Reimbursement',
						data: null,
						bSortable: true,
						mRender: (data) => {
							const result = (data.totalNewReimbursementToEmployee ?? 0) - (data.totalReimbursementToEmployee ?? 0);
							return `$${result.toFixed(2)}`;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.OutofCountyTravelAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CostAllocationForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) {
								return '';
							}
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const url = `${environment.baseUrl}/#/project-grants/cost-allocation-form/view/${data.id}`;
							return `<a href="javascript:void(0);" data-url="${url}" data-direct="${!appendQueryString}"
														onclick="window.openUrl(this)" 
														class="btn btn-link">View Form</a>`;
						},
					},
				];
				break;
			case FormOptions.CustomizedTaskForm:
				baseOptions.columns = [
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Due Date',
						data: 'dueDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomizedTaskForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.EnhancementRequestForm:
				baseOptions.columns = [
					{ title: 'Enhancement Request Summary', data: 'summary', bSortable: true },
					{
						title: 'Request Type',
						data: null,
						mRender: (data) => {
							return data.requestType;
						},
						bSortable: true,
					},
					{ title: 'Module', data: 'module', bSortable: true },
					{ title: 'Module Section', data: 'moduleSection', bSortable: true },
					{ title: 'Module Item', data: 'item', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const url = `${environment.baseUrl}/#/forms/enhancement-request-form/${data.id}`;
							return `<a href="javascript:void(0);" data-url="${url}"
									onclick="window.openUrl(this)" 
									class="btn btn-link">View Form</a>`;
						},
					},
				];
				break;
			case FormOptions.ProjectGrantComplianceForm:
				baseOptions.columns = [
					{
						title: 'Task Name',
						data: 'name',
						bSortable: true,
						width: '200px',
					},
					{
						title: 'Description',
						data: 'description',
						bSortable: true,
						width: '200px',
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ProjectGrantComplianceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.ThirdPartyIntegrationForm:
				baseOptions.columns = [
					{ title: 'Entry Number', data: 'journalEntryNumber', visible: false },
					{ title: 'Provider', data: 'providerName', bSortable: true },
					{ title: 'Type', data: 'typeName', bSortable: true },
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data?.feeEntries && data.feeEntries.length > 0) {
								let totalAmount = data.feeEntries
									.filter((x) => x.credit)
									.map((x) => x.credit)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.ThirdPartyIntegrationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.AccessChangeForm:
				baseOptions.columns = [
					{ title: 'Module', data: 'moduleName', bSortable: true },
					{ title: 'Item', data: 'itemName', bSortable: true },
					{ title: 'Item Type', data: 'itemType', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.AccessChangeForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.InvestmentActivityRecordingForm:
				baseOptions.columns = [
					{
						title: 'Fiscal Year Start',
						data: 'startFiscalYear',
						defaultContent: '',
						bSortable: true,
					},
					{
						title: 'Fiscal Month Start',
						data: 'startMonth',
						defaultContent: '',
						bSortable: true,
						mRender: function (data) {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return data != null && data >= 0 && data < monthNames.length ? monthNames[data] : '';
						},
					},
					{
						title: 'Fiscal Year End',
						data: 'endFiscalYear',
						defaultContent: '',
						bSortable: true,
					},
					{
						title: 'Fiscal Month End',
						data: 'endMonth',
						defaultContent: '',
						bSortable: true,
						mRender: function (data) {
							const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
							return data != null && data >= 0 && data < monthNames.length ? monthNames[data] : '';
						},
					},
					{ title: 'Additional Comments', data: 'additionalComments', defaultContent: '', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', defaultContent: '', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						defaultContent: '',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (!data || data.completedDate == null) {
								return '';
							}
							return moment(data.completedDate).format('MM/DD/YYYY h:mm A');
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.InvestmentActivityRecordingForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomizationRequestForm:
				baseOptions.columns = [
					{ title: 'Item', data: 'itemName', bSortable: true },
					{ title: 'Request Title', data: 'requestTitle', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.CustomizationRequestForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.MassInvoiceCreationForm:
				baseOptions.columns = [
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.MassInvoiceCreationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			case FormOptions.BillingForm:
				baseOptions.columns = [
					{ title: 'Name', data: 'name', bSortable: true },
					{ title: 'Slug', data: 'slug', bSortable: true },
					{ title: 'Description', data: 'description', bSortable: true },
					{ title: 'Category', data: 'category', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button  data-id="${data.id}" data-type="${FormOptions.BillingForm}" class="btn btn-link view">View Form</button>`;
						},
					},
				];
				break;
			default:
				break;
		}
		return baseOptions;
	}

	// The columns using this have their own mRender, which replaces the columnDefs `_all` escape,
	// so the joined text has to be escaped here before DataTables writes it as HTML.
	private joinPoRollbackDetails(form: any, select: (detail: any) => any): string {
		const values = (form?.poRollbackDetails ?? [])
			.map((detail) => select(detail))
			.filter((value) => value !== null && value !== undefined && value !== '');
		return this.escapeHtml([...new Set(values)].join(', '));
	}

	private sumPoRollbackBalance(form: any): number {
		return (form?.poRollbackDetails ?? []).reduce((total, detail) => total + (detail.balance ?? 0), 0);
	}

	getFormOption(formId: string): FormOptions {
		switch (formId) {
			case 'budget-amend':
				return FormOptions.BudgetAmendment;
			case 'dpt-exp-budget':
				return FormOptions.DptExpenseBudget;
			case 'budget-transfer':
				return FormOptions.BudgetTransfer;
			case 'change-order':
				return FormOptions.ChangeOrder;
			case 'ap-invoice':
				return FormOptions.APInvoice;
			case 'p-card':
				return FormOptions.PCard;
			case 'purchasing':
				return FormOptions.Purchasing;
			case 'tasks':
				return FormOptions.Request;
			case 'check-request':
				return FormOptions.CheckRequest;
			case 'ye-request':
				return FormOptions.YeRequest;
			case 'fieldwork-request':
				return FormOptions.FieldWorkRequest;
			case 'new-project':
				return FormOptions.NewProject;
			case 'invoice-approval':
				return FormOptions.InvoiceApproval;
			case 'cc-approval':
				return FormOptions.CCApproval;
			case 'task-request':
				return FormOptions.AclarianTask;
			case 'timesheet':
				return FormOptions.TimeSheet;
			case 'monthly-timesheet':
				return FormOptions.MonthlyTimeSheet;
			case 'hr-support':
				return FormOptions.HRSupport;
			case 'vendor-form':
				return FormOptions.VendorForm;
			case 'bid-form':
				return FormOptions.BidForm;
			case 'fund-rev-budget':
				return FormOptions.NYRevenueBudget;
			case 'capital-budget':
				return FormOptions.NYCapitalBudget;
			case 'operating-expense-budget':
				return FormOptions.NYOperatingExpenseBudget;
			case 'business-license':
				return FormOptions.BusinessLicense;
			case 'addition-form':
				return FormOptions.CapitalAdditionForm;
			case 'disposal-form':
				return FormOptions.CapitalDisposalForm;
			case 'transfer-form':
				return FormOptions.CapitalTransferForm;
			case 'journal-entry':
				return FormOptions.JournalEntryForm;
			case 'receipt-verification':
				return FormOptions.ReceiptVerification;
			case 'cashiering-report':
				return FormOptions.CashieringReport;
			case 'project-mgt-2':
				return FormOptions.ProjectManagement;
			case 'lease-evaluation':
				return FormOptions.LeaseEvaluation;
			case 'department-addition-form':
				return FormOptions.DepartmentAdditionForm;
			case 'fund-addition-form':
				return FormOptions.FundAdditionForm;
			case 'personnel-budget-form':
				return FormOptions.PersonnelManagement;
			case 'funding-increase-form':
				return FormOptions.FundingIncreaseForm;
			case 'payment-approval-form':
				return FormOptions.PaymentApprovalForm;
			case 'contract-approval':
				return FormOptions.ContractApproval;
			case 'gl-account':
				return FormOptions.AccountCreation;
			case 'project-close-form':
				return FormOptions.ProjectCloseForm;
			case 'po-rollover-form':
				return FormOptions.PoRolloverForm;
			case 'po-rollback-form':
				return FormOptions.PoRollbackForm;
			case 'project-open-form':
				return FormOptions.ProjectOpenForm;
			case 'customer-invoice-form':
				return FormOptions.CustomerInvoiceForm;
			case 'customer-form':
				return FormOptions.CustomerForm;
			case 'quick-invoice-form':
				return FormOptions.QuickInvoiceForm;
			case 'quick-pay':
				return FormOptions.QuickPayForm;
			case 'bank-reconciliation':
				return FormOptions.BankReconciliation;
			case 'work-order-request':
				return FormOptions.WorkOrderRequestForm;
			case 'project-grant-form':
				return FormOptions.ProjectGrantForm;
			case 'project-grant-task':
				return FormOptions.ProjectGrantTask;
			case 'project-grant-close-form':
				return FormOptions.ProjectGrantCloseForm;
			case 'project-grant-reopen-form':
				return FormOptions.ProjectGrantReopenForm;
			case 'open-close-period':
				return FormOptions.OpenClosePeriod;
			case 'job-application':
				return FormOptions.JobApplication;
			case 'employee-action-form':
				return FormOptions.EmployeeActionForm;
			case 'void-reissue-form':
				return FormOptions.VoidReissueForm;
			case 'payment-adjustment-form':
				return FormOptions.PaymentAdjustmentForm;
			case 'time-off-request-form':
				return FormOptions.TimeOff;
			case 'weekly-timesheet':
				return FormOptions.HrisTimeSheet;
			case 'performance-evaluation':
				return FormOptions.PerformanceEvaluation;
			case 'benefit-enrolment-form':
				return FormOptions.BenefitEnrolmentForm;
			case 'cash-receipt-form':
				return FormOptions.CashReceiptForm;
			case 'credit-card-report':
				return FormOptions.CreditCardReport;
			case 'individual-payee-form':
				return FormOptions.IndividualPayeeForm;
			case 'individual-payment-form':
				return FormOptions.IndividualPaymentForm;
			case 'depreciation-schedule-form':
				return FormOptions.DepreciationScheduleForm;
			case 'new-debt-issuance-form':
				return FormOptions.NewDebtIssuanceForm;
			case 'debt-service-payment-form':
				return FormOptions.DebtServicePaymentForm;
			case 'debt-covenant-compliance-form':
				return FormOptions.DebtCovenantComplianceForm;
			case 'debt-investment-je-form':
				return FormOptions.DebtInvestmentJournalEntryForm;
			case 'investment-security-purchase-form':
				return FormOptions.InvestmentSecurityPurchaseForm;
			case 'new-capital-lease-form':
				return FormOptions.NewCapitalLeaseForm;
			case 'lease-modification-form':
				return FormOptions.LeaseModificationForm;
			case 'implementation-billing-ar':
				return FormOptions.Implementation;
			case 'implementation-general-ledger':
				return FormOptions.ImplementationGL;
			case 'new-hire-form':
				return FormOptions.NewHireForm;
			case 'new-template':
				return FormOptions.RecurringTemplate;
			case 'implementation-purchasing':
				return FormOptions.ImplementationPurchasing;
			case 'leave-balance-adjustment':
				return FormOptions.LeaveBalanceAdjustmentForm;
			case 'implementation-payment':
				return FormOptions.ImplementationPayment;
			case 'customer-refund-form':
				return FormOptions.CustomerRefundForm;
			case 'workflow-group-form':
				return FormOptions.WorkflowGroup;
			case 'user-form':
				return FormOptions.UserWorkflowForm;
			case 'invoice-adjustment-form':
				return FormOptions.CustomerInvoiceAdjustmentForm;
			case 'timesheet-approval-form':
				return FormOptions.TimeSheetApprovalForm;
			case 'implementation-hr':
				return FormOptions.ImplementationHR;
			case 'travel-pre-approval':
				return FormOptions.TravelPreApprovalForm;
			case 'travel-reimbursement':
				return FormOptions.TravelReimbursementForm;
			case 'reclassification-form':
				return FormOptions.CapitalReclassification;
			case 'electronic-ach-report':
				return FormOptions.ElectronicAchReport;
			case 'request-form':
				return FormOptions.RequestForm;
			case 'create-invoice-form':
				return FormOptions.CreateInvoiceForm;
			case 'usage-adjustment-form':
				return FormOptions.UsageAdjustmentForm;
			case 'fee-adjustment-form':
				return FormOptions.FeeAdjustmentForm;
			case 'complainant-form':
				return FormOptions.ComplainantForm;
			case 'tax-distribution':
				return FormOptions.TaxDistributionForm;
			case 'tuition-reimbursement':
				return FormOptions.TuitionReimbursementForm;
			case 'tuition-reimbursement-payment':
				return FormOptions.TuitionReimbursementPaymentForm;
			case 'purchasing-employee-form':
				return FormOptions.PurchasingEmployee;
			case 'taxing-jurisdiction-form':
				return FormOptions.TaxingJurisdiction;
			case 'other-reimbursable-expenses':
				return FormOptions.OtherReimbursableExpensesForm;
			case 'local-vicinity':
				return FormOptions.LocalVicinityTravelForm;
			case 'out-of-county-travel':
				return FormOptions.OutofCountyTravelForm;
			case 'announcement-form':
				return FormOptions.Announcements;
			case 'fiserv-refund-form':
				return FormOptions.FiservRefundForm;
			case 'special-pay-form':
				return FormOptions.SpecialPayForm;
			case 'tuition-reimbursement-pre-approval':
				return FormOptions.TuitionReimbPreApprovalForm;
			case 'investment-income-allocation-form':
				return FormOptions.InvestmentIncomeAllocationForm;
			case 'individual-refund-form':
				return FormOptions.IndividualRefundForm;
			case 'tax-certificate-redemption-check':
				return FormOptions.TaxCertificateRedemptionCheckForm;
			case 'tax-certificate-redemption-ach-form':
				return FormOptions.TaxCertificateRedemptionACHForm;
			case 'go-live-approval-form':
				return FormOptions.GoLiveApprovalForm;
			case 'training-certification-form':
				return FormOptions.TrainingCertificationForm;
			case 'location-form':
				return FormOptions.LocationForm;
			case 'item-form':
				return FormOptions.ItemForm;
			case 'receiving-form':
				return FormOptions.ReceivingForm;
			case 'new-customer-form':
				return FormOptions.NewCustomerForm;
			case 'new-property-form':
				return FormOptions.NewPropertyForm;
			case 'new-customer-account-form':
				return FormOptions.NewCustomerAccountForm;
			case 'manual-meter-read-form':
				return FormOptions.ManualMeterReadForm;
			case 'meter-turn-on-form':
				return FormOptions.MeterTurnOnForm;
			case 'meter-turn-off-form':
				return FormOptions.MeterTurnOffForm;
			case 'cash-bond-form':
				return FormOptions.CashBondForm;
			case 'jury-check-registry-form':
				return FormOptions.JuryCheckRegistryForm;
			case 'mass-pay-rate-change-form':
				return FormOptions.MassPayRateChangeForm;
			case 'adjustment-form':
				return FormOptions.AdjustmentForm;
			case 'implementation-payroll':
				return FormOptions.ImplementationPayroll;
			case 'multiple-payment':
				return FormOptions.MultiplePayment;
			case 'cash-bond-payment-form':
				return FormOptions.CashBondPaymentForm;
			case 'usage-form':
				return FormOptions.UsageForm;
			case 'multiple-vendor-payment':
				return FormOptions.MultipleVendorPayment;
			case 'transaction-assignment-form':
				return FormOptions.TransactionAssignmentForm;
			case 'leave-balance-payout-form':
				return FormOptions.LeaveBalancePayoutForm;
			case 'payment-plan-form':
				return FormOptions.PaymentPlanForm;
			case 'meter-change-out-form':
				return FormOptions.MeterChangeOutForm;
			case 'payroll-adjustment-form':
				return FormOptions.PayrollAdjustmentForm;
			case 'other-bank-reconciliation':
				return FormOptions.OtherBankReconciliation;
			case 'asset-work-order-form':
				return FormOptions.CapitalWorkOrderForm;
			case 'customer-credit-memos':
				return FormOptions.CustomerCreditMemo;
			case 'vendor-credit-memos':
				return FormOptions.VendorCreditMemo;
			case 'other-tuition-reimbursement-payment':
				return FormOptions.OtherTuitionReimbursementPaymentForm;
			case 'other-tuition-reimbursement':
				return FormOptions.OtherTuitionReimbursementForm;
			case 'restitution-payment-form':
				return FormOptions.RestitutionPaymentForm;
			case 'customer-feedback-survey':
				return FormOptions.CustomerFeedbackSurveyForm;
			case 'field-purchase-order-request-form':
				return FormOptions.FieldRequestPaymentForm;
			case 'special-payment':
				return FormOptions.SpecialPayment;
			case 'initial-purchase-request-form':
				return FormOptions.InitialPurchaseRequestForm;
			case 'bulk-cash-receipt-form':
				return FormOptions.BulkCashReceiptForm;
			case 'daily-fees-import-form':
				return FormOptions.DailyFeesImportForm;
			case 'cashiering-adjustment-form':
				return FormOptions.CashieringAdjustmentForm;
			case 'cashiering-closeout-report':
				return FormOptions.CashieringCloseoutReport;
			case 'vendor-information-change-request':
				return FormOptions.VendorInformationChangeRequestForm;
			case 'employee-reimbursable-expenses':
				return FormOptions.EmployeeReimbursableExpensesForm;
			case 'cost-allocation-form':
				return FormOptions.CostAllocationForm;
			case 'contract-amendment':
				return FormOptions.ContractAmendment;
			case 'parent-vendor-form':
				return FormOptions.ParentVendorForm;
			case 'new-hire-request-form':
				return FormOptions.NewHireRequestForm;
			case 'policy-form':
				return FormOptions.PolicyForm;
			case 'procedure-form':
				return FormOptions.ProcedureForm;
			case 'out-of-county-travel-adjustment':
				return FormOptions.OutofCountyTravelAdjustmentForm;
			case 'travel-reimbursement-payment':
				return FormOptions.TravelReimbursementPaymentForm;
			case 'customized-task-form':
				return FormOptions.CustomizedTaskForm;
			case 'enhancement-request-form':
				return FormOptions.EnhancementRequestForm;
			case 'project-grant-compliance-form':
				return FormOptions.ProjectGrantComplianceForm;
			case 'third-party-integration-form':
				return FormOptions.ThirdPartyIntegrationForm;
			case 'investment-activity-recording-form':
				return FormOptions.InvestmentActivityRecordingForm;
			case 'customization-request-form':
				return FormOptions.CustomizationRequestForm;
			case 'access-change-form':
				return FormOptions.AccessChangeForm;
			case 'mass-invoice-creation-form':
				return FormOptions.MassInvoiceCreationForm;
			case 'billing-form':
				return FormOptions.BillingForm;
			default:
				return undefined;
		}
	}

	private escapeHtml(value: any): string {
		if (value == null) return '';
		const str = String(value);
		const div = document.createElement('div');
		div.appendChild(document.createTextNode(str));
		return div.innerHTML;
	}

	private stripHtml(value: any): string {
		if (value == null) return '';
		const str = String(value);
		if (!/<[^>]+>/.test(str)) return str;
		const normalized = str.replace(/<br\s*\/?>/gi, ' ').replace(/<\/(?:p|div|li|tr|h[1-6])>/gi, ' ');
		const div = document.createElement('div');
		div.innerHTML = normalized;
		return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
	}

	private tableOptionBase(dashboardData: BaseDashboard<any>, isQuickApproval: boolean): any {
		return {
			dom: 'Blfrtip',
			retrieve: true,
			pagingType: 'full_numbers',
			pageLength: 50,
			data: isQuickApproval ? dashboardData.formsForApproval : dashboardData.forms,
			lengthMenu: [
				[5, 10, 25, 50, -1],
				[5, 10, 25, 50, 'All'],
			],
			responsive: true,
			select: { style: 'single' },
			rowId: 'id',
			order: [[0, 'desc']],
			language: {
				search: '_INPUT_',
				searchPlaceholder: 'Search records',
			},
			columnDefs: [
				{
					targets: '_all',
					render: (data, type) => {
						if (type !== 'display') return data;
						return this.escapeHtml(data);
					},
				},
			],
			createdRow: (row: Node, data: any) => {
				if (data?.isFormUrgent) {
					$(row).addClass('urgent-form-record');
				}
			},
		};
	}

	exportDataToExcel(clientId: string, userId: string, formOption: FormOptions, request: any): Observable<any> {
		switch (formOption) {
			case FormOptions.YeRequest:
				return this.yeRequestService.exportToExcel(clientId, userId, request).pipe();
			case FormOptions.PaymentApprovalForm:
				return this.paymentApprovalFormService.exportToExcel(clientId, userId, request).pipe();
			default:
				return undefined;
		}
	}

	public getFormDisplayStatus(data, dashboardData) {
		let result = data.workflowStep;
		if (!result) {
			return '';
		}

		if (result === 'Denied' || result === 'Completed') {
			return result;
		}

		if (!dashboardData) {
			return result;
		}

		if (result.indexOf('Approval') >= 0 || result.indexOf('Approved') >= 0) {
			const hasItem = dashboardData.formsForApproval.find((t) => t.id === data.id);
			const group = dashboardData.groupNames?.find((x) => x.formId === data.id && x.isCurrent);
			const nameType = group?.groupName ? `(Group: ${group.groupName})` : `(User: ${group?.userName})`;
			result = hasItem ? `Needs Your Approval  ${nameType}` : 'Waiting Approval';
		} else if (result === 'Workflow Started' && data.createdBy === this.userId) {
			result = 'Needs Your Action';
		} else if (result === 'Fulfillment') {
			const hasItem = dashboardData.formsForApproval.find((t) => t.id === data.id);
			if (hasItem) {
				result = 'Needs Your Action';
			} else {
				result = 'In Fulfillment';
			}
		}
		return result;
	}

	isEnabledForQuickApproval(formOption: FormOptions) {
		const enabledForms = [
			FormOptions.CheckRequest,
			FormOptions.APInvoice,
			FormOptions.InvoiceApproval,
			FormOptions.OutofCountyTravelForm,
			FormOptions.QuickPayForm,
			FormOptions.Purchasing,
			FormOptions.CashBondForm,
			FormOptions.IndividualPaymentForm,
			FormOptions.CashBondPaymentForm,
			FormOptions.MultiplePayment,
			FormOptions.MultipleVendorPayment,
			FormOptions.OtherReimbursableExpensesForm,
			FormOptions.PCard,
			FormOptions.VendorCreditMemo,
			FormOptions.VoidReissueForm,
			FormOptions.PaymentAdjustmentForm,
			FormOptions.BidForm,
			FormOptions.ChangeOrder,
			FormOptions.ContractApproval,
			FormOptions.PurchasingEmployee,
			FormOptions.PoRolloverForm,
			FormOptions.VendorForm,
			FormOptions.CashReceiptForm,
			FormOptions.CashieringReport,
			FormOptions.JournalEntryForm,
			FormOptions.CustomerForm,
			FormOptions.CustomerInvoiceAdjustmentForm,
			FormOptions.CustomerInvoiceForm,
			FormOptions.QuickInvoiceForm,
		];
		return enabledForms.includes(formOption);
	}

	getQuickApprovalTableOptions(dashboardData: BaseDashboard<any>, formOption: FormOptions): any {
		const baseOptions = this.tableOptionBase(dashboardData, true);
		switch (formOption) {
			case FormOptions.CheckRequest:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'vendor', bSortable: true },
					{ title: 'Short Description', data: 'description', bSortable: false },
					{
						title: this.glSegmentation?.E1,
						data: null,
						bSortable: false,
						mRender: (data: CheckRequestView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									if (item.fundName) {
										val += `${item.fundName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'GLs',
						data: null,
						bSortable: false,
						mRender: (data: CheckRequestView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedgerId}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Total',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CheckRequest}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'check-request';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'check-request';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.APInvoice:
				baseOptions.columns = [
					{ title: 'PO #', data: 'poNumber' },
					{
						title: 'PO Amt',
						data: 'poAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{ title: 'PO Description ', data: 'invoiceDescription' },
					{ title: 'Invoice #', data: 'invoiceNumber', bSortable: true },
					{
						title: 'Invoice Amount',
						data: 'invoiceAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{ title: 'Vendor Name', data: 'vendor' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.APInvoice}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'ap-invoice';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'ap-invoice';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.QuickPayForm:
				baseOptions.columns = [
					{
						title: 'Payee Name',
						data: 'vendor',
						bSortable: true,
					},
					{ title: 'Short Description', data: 'description', bSortable: false },
					{
						title: this.glSegmentation?.E1,
						data: null,
						bSortable: false,
						mRender: (data: QuickPayView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									if (item.fundName) {
										val += `${item.fundName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'GLs',
						data: null,
						bSortable: false,
						mRender: (data: QuickPayView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedgerId}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Total',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data && data.accounts.length > 0) {
								const totalAmount = data.accounts
									.filter((x) => x.amount)
									.map((x) => x.amount)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.QuickPayForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'quick-pay';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'quick-pay';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.Purchasing:
				baseOptions.columns = [
					{ title: 'Fiscal Year', data: 'fiscalYear' },
					{ title: 'Vendor', data: 'vendor' },
					{ title: 'Procurement Method', data: 'description' },
					{
						title: 'Po Number',
						data: 'poNumber',
						mRender: (data) => {
							return data ? data : 'N/A';
						},
					},
					{
						title: 'Total PO Amount',
						data: 'totalpOAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.Purchasing}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'purchasing';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'purchasing';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CashBondForm:
				baseOptions.columns = [
					{ title: 'Bond Number', data: 'bondNumber', bSortable: true },
					{ title: 'Depositor Name', data: 'depositorName', bSortable: true },
					{ title: 'Defendant Name', data: 'defendantName', bSortable: true },
					{
						title: 'Bond Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return `$${data.bondAmount}`;
						},
					},
					{
						title: 'Date Received',
						data: 'dateReceived',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CashBondForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'cash-bond-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'cash-bond-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.IndividualPaymentForm:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'payeeName', bSortable: true },
					{ title: 'Short Description', data: 'description', bSortable: false },
					{
						title: this.glSegmentation?.E1,
						data: null,
						bSortable: false,
						mRender: (data: IndividualPaymentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									if (item.fundName) {
										val += `${item.fundName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'GLs',
						data: null,
						bSortable: false,
						mRender: (data: IndividualPaymentView) => {
							let val = '';
							if (data?.accounts?.length > 0) {
								for (const item of data.accounts) {
									val += `${item.generalLedgerId}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Total',
						data: 'amount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.IndividualPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'individual-payment-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'individual-payment-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CashBondPaymentForm:
				baseOptions.columns = [
					{ title: 'Bond Number', data: 'bondNumber', bSortable: true },
					{ title: 'Depositor Name', data: 'depositorName', bSortable: true },
					{ title: 'Defendant Name', data: 'defendantName', bSortable: true },
					{
						title: 'Disbursed Date',
						data: 'disbursedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CashBondPaymentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'cash-bond-payment-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'cash-bond-payment-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.MultiplePayment:
				baseOptions.columns = [
					{ title: 'Payee Name', data: 'payeeName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Batch Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Description', data: 'description', bSortable: true },
					{
						title: 'Total Amount',
						data: 'totalAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.MultiplePayment}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'multiple-payment';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'multiple-payment';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.BidForm:
				baseOptions.columns = [
					{ title: 'Bid Name', data: 'bidName' },
					{ title: 'Bid Number', data: 'bidNumber' },
					{
						title: 'Department(S)',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.bidApplicableDepartments?.length > 0) {
								for (const item of data.bidApplicableDepartments) {
									if (item.departmentName) {
										val += `${item.departmentName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.BidForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'bid-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'bid-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.MultipleVendorPayment:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendorName', defaultContent: '', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						defaultContent: '',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Invoice Number', data: 'invoiceNumber', defaultContent: '', bSortable: true },
					{ title: 'Description', data: 'description', defaultContent: '', bSortable: true },
					{
						title: 'Amount',
						data: 'totalPaymentAmount',
						defaultContent: '$0.00',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', defaultContent: '', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						defaultContent: '',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.multipleVendorPaymentId}" data-type="${FormOptions.MultipleVendorPayment}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'multiple-vendor-payment';
								return `<button data-id="${data.multipleVendorPaymentId}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'multiple-vendor-payment';
							return `<button data-id="${data.multipleVendorPaymentId}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.OtherReimbursableExpensesForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department',
						data: 'department',
						bSortable: true,
					},
					{
						title: 'Total Reimbursement',
						data: 'totalReimbursementAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.OtherReimbursableExpensesForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'other-reimbursable-expenses';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'other-reimbursable-expenses';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.PCard:
				baseOptions.columns = [
					{
						title: 'Statement End Date',
						data: 'statementEndDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Card Holder', data: 'cardHolder', bSortable: true },
					{
						title: 'Total Amount',
						data: 'totalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.PCard}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'p-card';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'p-card';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.VendorCreditMemo:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendorName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Credit Memo Date',
						data: 'creditMemoDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{ title: 'Short Description', data: 'shortDescription', bSortable: true },
					{ title: 'Additional Details', data: 'additionalDetails', bSortable: true },
					{ title: 'Total', data: 'total', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },

					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.VendorCreditMemo}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'vendor-credit-memos';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'vendor-credit-memos';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.VoidReissueForm:
				baseOptions.columns = [
					{ title: 'Action', data: 'action' },
					{ title: 'Vendor Name', data: 'payeeName' },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Old Check Number', data: 'checkNo' },
					{ title: 'New Check Number', data: 'newCheckNo' },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.VoidReissueForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'void-reissue-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'void-reissue-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.PaymentAdjustmentForm:
				baseOptions.columns = [
					{ title: 'Source', data: 'source' },
					{ title: 'Payee Name', data: 'payeeName' },
					{ title: 'Check Number', data: 'checkNo' },
					{
						title: 'Original Amount',
						data: 'originalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Adjusted Amount',
						data: 'adjustedAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							if (data.completedDate == null) return '';
							return data ? moment(data.completedDate).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.PaymentAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'payment-adjustment-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'payment-adjustment-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.ChangeOrder:
				baseOptions.columns = [
					{ title: 'PO Number', data: 'poNumber' },
					{ title: 'Vendor Name', data: 'originalVendor' },
					{
						title: 'Original Amount',
						data: 'originalAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Revised Amount',
						data: 'revisedAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.ChangeOrder}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'change-order';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'change-order';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.ContractApproval:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'vendorName', bSortable: true },
					{
						title: 'Contract Start Date',
						data: 'contractStartDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Contract End Date',
						data: 'contractEndDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department(S)',
						data: null,
						bSortable: false,
						mRender: (data: any) => {
							let val = '';
							if (data?.contractLinkedDepartmentView?.length > 0) {
								for (const item of data.contractLinkedDepartmentView) {
									if (item.name) {
										val += `${item.name ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Contract Amount',
						data: 'contractAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.ContractApproval}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'contract-approval';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'contract-approval';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.PurchasingEmployee:
				baseOptions.columns = [
					{
						title: 'Employee Id',
						data: 'empId',
						bSortable: true,
					},
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Department',
						data: 'departmentName',
						bSortable: true,
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.PurchasingEmployee}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'purchasing-employee-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'purchasing-employee-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.PoRolloverForm:
				baseOptions.columns = [
					{ title: 'PO Number', data: 'poNumber', bSortable: true },
					{ title: 'Vendor Name', data: 'vendor', bSortable: true },
					{
						title: 'Remaining Balance',
						data: 'balance',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{ title: 'Rollover To Fiscal Year', data: 'rolloverToFiscalYear', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.PoRolloverForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'po-rollover-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'po-rollover-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.VendorForm:
				baseOptions.columns = [
					{ title: 'Vendor Name', data: 'name' },
					{ title: 'Legal Entity Names', data: 'legalName' },
					{
						title: 'Contact Name',
						data: null,
						mRender: (data: any) => {
							let val = '';
							if (data?.contacts?.length > 0) {
								for (const item of data.contacts) {
									if (item.contactName) {
										val += `${item.contactName ?? ''}<br />`;
									}
								}
							}
							return val;
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: null,
						bSortable: true,
						mRender: (data) => {
							let val = '';
							if (data?.requestedByEmails?.length > 0) {
								for (const item of data.requestedByEmails) {
									val += `${item}<br />`;
								}
							}
							return val;
						},
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.VendorForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'vendor-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'vendor-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CashReceiptForm:
				baseOptions.columns = [
					{ title: 'Reference Id', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{ title: 'Payment Mode', data: 'paymentMode', bSortable: true },
					{ title: 'Check Number', data: 'checkNo', bSortable: true },
					{
						title: 'Total Amount',
						data: 'total',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CashReceiptForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'cash-receipt-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'cash-receipt-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CashieringReport:
				baseOptions.columns = [
					{ title: 'Created By', data: 'createdByUserame' },
					{ title: 'Entry Number', data: 'journalEntryNumber', visible: false },
					{
						title: 'Total Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data?.cashieringEntries?.length > 0) {
								const totalAmount = data.cashieringEntries
									.filter((x) => x.amount)
									.map((x) => x.amount)
									.reduce((a, b) => a + b, 0);
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CashieringReport}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'cashiering-report';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'cashiering-report';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.JournalEntryForm:
				baseOptions.columns = [
					{ title: 'Entry Number', data: 'entryNumber', bSortable: true },
					{ title: 'Fiscal Year', data: 'effectiveYear', bSortable: true },
					{
						title: 'Fiscal Month',
						data: 'effectiveMonth',
						bSortable: true,
						mRender: (data) => {
							return data ? this.utilityService.getMonthNameFromNumber(data) : '';
						},
					},
					{
						title: 'Amount',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data?.entries?.length > 0) {
								let totalAmount = 0;
								for (const item of data.entries) {
									totalAmount += item.debit ?? 0;
								}
								return this.utilityService.formatCurrency(totalAmount);
							}
							return '';
						},
					},
					{ title: 'Short Description', data: 'shortDescription', bSortable: true },
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.JournalEntryForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'journal-entry';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'journal-entry';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerForm:
				baseOptions.columns = [
					{ title: 'Customer name', data: 'name', bSortable: true },
					{
						title: 'contact Name',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return data.contactName + ' ' + data.contactLastName;
						},
					},
					{ title: 'contact title', data: 'contactTitle', bSortable: true },
					{ title: 'contact phone', data: 'contactPhone', bSortable: true },
					{ title: 'Requested By', data: 'requestedBy' },
					{
						title: 'status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'created date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CustomerForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'customer-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'customer-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerInvoiceAdjustmentForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{ title: 'Description', data: 'description', bSortable: true },
					{
						title: 'Revised Invoiced Amount',
						data: 'revisedTotalAmount',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CustomerInvoiceAdjustmentForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'invoice-adjustment-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'invoice-adjustment-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.CustomerInvoiceForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerForm.name', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Description', data: 'invoiceDescription', bSortable: false },
					{
						title: 'Total Due',
						data: null,
						bSortable: true,
						mRender: (data) => {
							if (data.invoiceStatus?.includes('Carried Over To Invoice')) {
								return this.utilityService.formatCurrency(0);
							}
							return this.utilityService.formatCurrency(data.totalDue ?? 0);
						},
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: false },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.CustomerInvoiceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'customer-invoice-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'customer-invoice-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.QuickInvoiceForm:
				baseOptions.columns = [
					{ title: 'Invoice Number', data: 'referenceId', bSortable: true },
					{ title: 'Customer Name', data: 'customerName', bSortable: true },
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{ title: 'Description', data: 'invoiceDescription', bSortable: true },
					{
						title: 'Total Due',
						data: 'totalDue',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.QuickInvoiceForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'quick-invoice-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'quick-invoice-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.InvoiceApproval: {
				const invoiceApprovalFormType = 'invoice-approval';
				baseOptions.columns = [];
				if (this.userService.currentUserValue.user.clientId === 'cfb1b93d-8bf9-492a-bc9d-5817de48a3e2') {
					baseOptions.columns.push(
						{ title: 'Project Manager', data: 'projectManager', visible: false },
						{ title: 'Project #', data: 'projectNumber' },
						{ title: 'Project Title', data: 'projectName' }
					);
				}
				baseOptions.columns.push(
					{ title: 'Invoice Number', data: 'invoiceNumber', bSortable: true },
					{ title: 'Vendor Name', data: 'vendorName' },
					{
						title: 'Invoice Amount',
						data: 'invoiceAmount',
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.InvoiceApproval}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								return `<button data-id="${data.id}" data-type="${invoiceApprovalFormType}" class="btn btn-link edit">Approve Form</button>`;
							}
							return '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${invoiceApprovalFormType}" class="btn btn-link document">View Document</button>`;
						},
					}
				);
				break;
			}
			case FormOptions.OutofCountyTravelForm:
				baseOptions.columns = [
					{
						title: 'Employee Name',
						data: 'name',
						bSortable: true,
					},
					{
						title: 'Invoice Date',
						data: 'invoiceDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY') : '';
						},
					},
					{
						title: 'Department',
						data: 'department',
						bSortable: true,
					},
					{
						title: 'Purpose Of Trip',
						data: 'purposeOfTravel',
						bSortable: true,
					},
					{
						title: 'Total Reimbursement',
						data: 'totalReimbursementToEmployee',
						bSortable: true,
						render: $.fn.dataTable.render.number(',', '.', 2, '$'),
					},
					{
						title: 'Status',
						data: null,
						bSortable: true,
						mRender: (data) => {
							return this.getFormDisplayStatus(data, dashboardData);
						},
					},
					{
						title: 'Requested By',
						data: 'requestedBy',
						bSortable: true,
					},
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: null,
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							const completedDate = data?.completedDate;
							return completedDate == null ? '' : moment(completedDate).format('MM/DD/YYYY h:mm A');
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.OutofCountyTravelForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								return `<button data-id="${data.id}" data-type="out-of-county-travel" class="btn btn-link edit">Approve Form</button>`;
							}
							return '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="out-of-county-travel" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			case FormOptions.MassInvoiceCreationForm:
				baseOptions.columns = [
					{ title: 'Requested By', data: 'requestedBy', bSortable: true },
					{
						title: 'Created Date',
						data: 'createdDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: 'Modified Date',
						data: 'completedDate',
						type: 'date',
						bSortable: true,
						mRender: (data) => {
							return data ? moment(data).format('MM/DD/YYYY h:mm A') : '';
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							return `<button data-id="${data.id}" data-type="${FormOptions.MassInvoiceCreationForm}" class="btn btn-link view">View Form</button>`;
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const displayStatus = this.getFormDisplayStatus(data, dashboardData);
							if (displayStatus?.startsWith('Needs Your Approval')) {
								const formType = 'mass-invoice-creation-form';
								return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link edit">Approve Form</button>`;
							} else {
								return '';
							}
						},
					},
					{
						title: '',
						data: null,
						bSortable: false,
						width: '100px',
						mRender: (data) => {
							const formType = 'mass-invoice-creation-form';
							return `<button data-id="${data.id}" data-type="${formType}" class="btn btn-link document">View Document</button>`;
						},
					},
				];
				break;
			default:
				break;
		}
		return baseOptions;
	}

	public getApprovalCall(formType: any, formId: any) {
		switch (formType) {
			case 'quick-pay':
				return this.quickPayService.approveForm(this.clientId, formId, this.userId);
			case 'ap-invoice':
				return this.apInvoiceService.approveForm(this.clientId, formId, this.userId);
			case 'check-request':
				return this.getServiceByFormId(formType).approveForm(this.clientId, formId, this.userId);
			case 'purchasing':
				return this.purchasingFormService.approveForm(this.clientId, formId, this.userId);
			case 'cash-bond-form':
				return this.cashBondFormService.approveForm(this.clientId, formId, this.userId);
			case 'individual-payment-form':
				return this.individualPaymentFormService.approveForm(this.clientId, formId, this.userId);
			case 'cash-bond-payment-form':
				return this.cashBondPaymentService.approveForm(this.clientId, formId, this.userId);
			case 'multiple-payment':
				return this.multiplePaymentService.approveForm(this.clientId, formId, this.userId);
			case 'multiple-vendor-payment':
				return this.multipleVendorPaymentService.approveForm(this.clientId, formId, this.userId);
			case 'other-reimbursable-expenses':
				return this.otherReimbursableExpensesService.approveForm(this.clientId, formId, this.userId);
			case 'p-card':
				return this.pCardService.approveForm(this.clientId, formId, this.userId);
			case 'vendor-credit-memos':
				return this.vendorCreditMemoService.approveForm(this.clientId, formId, this.userId);
			case 'void-reissue-form':
				return this.voidReissueFormService.approveForm(this.clientId, formId, this.userId);
			case 'bid-form':
				return this.bidService.approveForm(this.clientId, formId, this.userId);
			case 'change-order':
				return this.changeOrderService.approveForm(this.clientId, formId, this.userId);
			case 'contract-approval':
				return this.contractApprovalFormServices.approveForm(this.clientId, formId, this.userId);
			case 'purchasing-employee-form':
				return this.purchasingEmployeeService.approveForm(this.clientId, formId, this.userId);
			case 'po-rollover-form':
				return this.poRolloverService.approveForm(this.clientId, formId, this.userId);
			case 'po-rollback-form':
				return this.poRollbackService.approveForm(this.clientId, formId, this.userId);
			case 'vendor-form':
				return this.vendorService.approveForm(this.clientId, formId, this.userId);
			case 'cash-receipt-form':
				return this.cashReceiptFormService.approveForm(this.clientId, formId, this.userId);
			case 'cashiering-report':
				return this.cashieringReportService.approveForm(this.clientId, formId, this.userId);
			case 'journal-entry':
				return this.journalEntryFormService.approveForm(this.clientId, formId, this.userId);
			case 'customer-form':
				return this.customerFormService.approveForm(this.clientId, formId, this.userId);
			case 'invoice-adjustment-form':
				return this.customerInvoiceAdjustmentFormService.approveForm(this.clientId, formId, this.userId);
			case 'customer-invoice-form':
				return this.customerInvoiceFormService.approveForm(this.clientId, formId, this.userId);
			case 'quick-invoice-form':
				return this.quickInvoiceFormService.approveForm(this.clientId, formId, this.userId);
			case 'mass-invoice-creation-form':
				return this.massInvoiceCreationFormService.approveForm(this.clientId, formId, this.userId);
			case 'invoice-approval':
				return this.invoiceApprovalService.approveForm(this.clientId, formId, this.userId);
			case 'out-of-county-travel':
				return this.outofCountyTravelService.approveForm(this.clientId, formId, this.userId);
			default:
				return undefined;
		}
	}

	public getFormCall(formType: any, formId: any) {
		switch (formType) {
			case 'quick-pay':
				return this.quickPayService.getForm(this.clientId, formId);
			case 'ap-invoice':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'check-request':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'purchasing':
				return this.purchasingFormService.getForm(formId, this.clientId);
			case 'cash-bond-form':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'individual-payment-form':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'cash-bond-payment-form':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'multiple-payment':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'multiple-vendor-payment':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'other-reimbursable-expenses':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'p-card':
				return this.pCardService.getForm(formId, this.clientId);
			case 'vendor-credit-memos':
				return this.getServiceByFormId(formType).get(this.clientId, formId);
			case 'void-reissue-form':
				return this.voidReissueFormService.getForm(this.clientId, formId);
			case 'bid-form':
				return this.bidService.getForm(formId, this.clientId);
			case 'change-order':
				return this.changeOrderService.getForm(formId, this.clientId);
			case 'contract-approval':
				return this.contractApprovalFormServices.getForm(this.clientId, formId);
			case 'purchasing-employee-form':
				return this.purchasingEmployeeService.getForm(this.clientId, formId);
			case 'po-rollover-form':
				return this.poRolloverService.getForm(formId, this.clientId);
			case 'po-rollback-form':
				return this.poRollbackService.getForm(formId, this.clientId);
			case 'vendor-form':
				return this.vendorService.getForm(formId, this.clientId);
			case 'cash-receipt-form':
				return this.cashReceiptFormService.getForm(this.clientId, formId);
			case 'cashiering-report':
				return this.cashieringReportService.getForm(formId, this.clientId);
			case 'journal-entry':
				return this.journalEntryFormService.getForm(this.clientId, formId);
			case 'customer-form':
				return this.customerFormService.getForm(this.clientId, formId);
			case 'invoice-adjustment-form':
				return this.customerInvoiceAdjustmentFormService.getForm(this.clientId, formId);
			case 'customer-invoice-form':
				return this.customerInvoiceFormService.getForm(this.clientId, formId);
			case 'quick-invoice-form':
				return this.quickInvoiceFormService.getForm(this.clientId, formId);
			case 'mass-invoice-creation-form':
				return this.massInvoiceCreationFormService.getForm(this.clientId, formId);
			case 'invoice-approval':
				return this.invoiceApprovalService.getForm(formId, this.clientId);
			case 'out-of-county-travel':
				return this.outofCountyTravelService.get(this.clientId, formId);
			default:
				return undefined;
		}
	}

	public getService(formType: FormOptions): BaseFormService {
		switch (formType) {
			case FormOptions.PersonnelManagement:
				return this.personnelBudgetServices;
			case FormOptions.NYCapitalBudget:
				return this.capitalBudgetService;
			case FormOptions.NYRevenueBudget:
				return this.fundRevenueBudgetService;
			case FormOptions.CapitalReclassification:
				return this.reclassificationFormService;
			case FormOptions.APInvoice:
				return this.apInvoiceService;
			case FormOptions.CheckRequest:
				return this.checkRequestService;
			case FormOptions.ComplainantForm:
				return this.complainantFormService;
			case FormOptions.DptExpenseBudget:
				return this.dptExpenseBudgetServices;
			case FormOptions.TaxDistributionForm:
				return this.taxDistributionSerivce;
			case FormOptions.CashBondForm:
				return this.cashBondFormService;
			case FormOptions.CustomerCreditMemo:
				return this.customerCreditMemoService;
			case FormOptions.RestitutionPaymentForm:
				return this.restitutionPaymentService;
			case FormOptions.IndividualPaymentForm:
				return this.individualPaymentFormService;
			case FormOptions.NYOperatingExpenseBudget:
				return this.operatingExpenseBudgetServices;
			case FormOptions.CashBondPaymentForm:
				return this.cashBondPaymentService;
			case FormOptions.MultiplePayment:
				return this.multiplePaymentService;
			case FormOptions.MultipleVendorPayment:
				return this.multipleVendorPaymentService;
			case FormOptions.OtherReimbursableExpensesForm:
				return this.otherReimbursableExpensesService;
			case FormOptions.VendorCreditMemo:
				return this.vendorCreditMemoService;
			case FormOptions.ThirdPartyIntegrationForm:
				return this.thirdPartyIntegrationFormService;
			case FormOptions.AccessChangeForm:
				return this.accessChangeFormService;
			case FormOptions.SpecialPayment:
				return this.specialPaymentService;
			default:
				return undefined;
		}
	}

	public getServiceByFormId(formId: string): BaseFormService {
		return this.getService(this.getFormOption(formId));
	}

	public getComletedFormsReport(clientId, formId, search) {
		const formOption: FormOptions = this.getFormOption(formId);
		const service = this.formServiceMap[formOption];

		if (!service) {
			return 'No service found for form option';
		}

		return service.getCompletedForm(clientId, formId, search);
	}

	private readonly assignmentSourceDropdownMap: Record<string, string> = {
		'Check Request Form': 'check-request',
		'AP Invoice Form': 'ap-invoice',
		'P-Card Form': 'p-card',
		'Quick Pay Form': 'quick-pay',
		'Individual Payment Form': 'individual-payment-form',
		'Other Reimbursable Expenses': 'other-reimbursable-expenses',
		'Invoice Form': 'customer-invoice-form',
		'Cash Receipt Form': 'cash-receipt-form',
		'Quick Invoice Form': 'quick-invoice-form',
		'Multiple Vendor Payment': 'multiple-vendor-payment',
		'Multiple Payment': 'multiple-payment',
		'Employee Reimbursable Expenses': 'employee-reimbursable-expenses',
		'Cost Allocation Form': 'cost-allocation-form',
		'Journal Entry Form': 'journal-entry',
	};

	public getAssignmentLink(sourceName: string, sourceId: string): string {
		if (!sourceName || !sourceId) {
			return '';
		}
		const dropdownSource = this.assignmentSourceDropdownMap[sourceName];
		if (!dropdownSource) {
			return '';
		}
		const formUrl = this.getFormLinkOnly(sourceId, sourceName);
		const href =
			`#/project-grants/transaction-assignment-form` +
			`?source=${encodeURIComponent(dropdownSource)}` +
			`&formUrl=${encodeURIComponent(formUrl)}`;
		return `<a target="_blank" rel="noopener noreferrer" href="${href}" class="btn btn-sm btn-warning" style="color:black;">Start Assignment</a>`;
	}

	public getFormLink(sourceName: string, formId: string): string {
		switch (sourceName) {
			case 'Quick Pay':
			case 'Quick Pay Form':
				return (
					'<a target="_blank" href="#/forms/quick-pay/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'P-Card':
			case 'P-Card Form':
				return (
					'<a target="_blank" href="#/forms/p-card/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Check Request Form':
			case 'CheckRequest':
			case 'Check Request':
				return (
					'<a target="_blank" href="#/forms/check-request/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Individual Payment Form':
				return (
					'<a target="_blank" href="#/forms/individual-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Customer Refund Form':
				return (
					'<a target="_blank" href="#/forms/customer-refund-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Invoice Approval Form w/PO':
			case 'APInvoice':
			case 'AP Invoice Form':
				return (
					'<a target="_blank" href="#/forms/ap-invoice/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Fiserv Refund Form':
				return (
					'<a target="_blank" href="#/forms/fiserv-refund-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Out Of County Travel':
				return (
					'<a target="_blank" href="#/forms/out-of-county-travel/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Local Vicinity Travel':
				return (
					'<a target="_blank" href="#/forms/local-vicinity/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Other Reimbursable Expenses':
				return (
					'<a target="_blank" href="#/forms/other-reimbursable-expenses/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Individual Refund Form Detail':
			case 'IndividualRefundFormDetail':
				return (
					'<a target="_blank" href="#/forms/individual-refund-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Tax Certificate Redemption Check Form Detail':
				return (
					'<a target="_blank" href="#/forms/tax-certificate-redemption-check/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Tuition Reimbursement Payment':
				return (
					'<a target="_blank" href="#/forms/tuition-reimbursement-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Tuition Reimbursement':
				return (
					'<a target="_blank" href="#/forms/tuition-reimbursement/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Tax Distribution':
				return (
					'<a target="_blank" href="#/forms/tax-distribution/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Tax Certificate Redemption ACH Form':
				return (
					'<a target="_blank" href="#/forms/tax-certificate-redemption-ach-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Jury Check Registry Form':
			case 'Jury Check Registry Form Detail':
				return (
					'<a target="_blank" href="#/forms/jury-check-registry-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Journal Entry Form':
			case 'JournalEntry':
				return (
					'<a target="_blank" href="#/generalledger/journal-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'tax-distribution':
				return (
					'<a target="_blank" href="#/forms/tax-distribution/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'VoidReissueForm':
				return (
					'<a target="_blank" href="#/forms/void-reissue-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'PaymentAdjustmentForm':
				return (
					'<a target="_blank" href="#/forms/payment-adjustment-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Multiple Payment':
				return (
					'<a target="_blank" href="#/forms/multiple-payment/view/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Invoice Form':
				return (
					'<a target="_blank" href="#/miscellaneous-billing/customer-invoice/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Multiple Vendor Payment':
				return (
					'<a target="_blank" href="#/forms/multiple-vendor-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Multiple Payee Payment':
				return (
					'<a target="_blank" href="#/forms/multiple-vendor-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'ElectronicAchReport':
			case 'Electronic/ACH Report':
				return (
					'<a target="_blank" href="#/forms/electronic-ach-report/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Other Tuition Reimbursement Payment':
				return (
					'<a target="_blank" href="#/forms/other-tuition-reimbursement-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Quick Invoice Form':
				return (
					'<a target="_blank" href="#/miscellaneous-billing/quick-invoice/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Cash Receipt Form':
				return (
					'<a target="_blank" href="#/miscellaneous-billing/cash-receipt-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Cash Bond Payee':
				return (
					'<a target="_blank" href="#/forms/cash-bond-payment-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Restitution Payment Form Detail':
				return (
					'<a target="_blank" href="#/forms/restitution-payment-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Special Payment':
				return (
					'<a target="_blank" href="#/forms/special-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Bulk Cash Receipt Form':
				return (
					'<a target="_blank" href="#/miscellaneous-billing/bulk-cash-receipt-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Daily-fees Import Form':
				return `<a target="_blank" href="#/forms/daily-fees-import-form/${formId}" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>`;
			case 'Cashiering Adjustment Form':
				return (
					'<a target="_blank" href="#/miscellaneous-billing/cashiering-adjustment-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Cashiering Closeout Report':
				return (
					'<a target="_blank" href="#/forms/cashiering-closeout-report/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Employee Reimbursable Expenses':
				return (
					'<a target="_blank" href="#/forms/employee-reimbursable-expenses/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Out Of County Travel Adjustment':
				return (
					'<a target="_blank" href="#/forms/out-of-county-travel-adjustment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Travel Reimbursement':
				return (
					'<a target="_blank" href="#/forms/travel-reimbursement-payment/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Cost Allocation Form':
				return (
					'<a target="_blank" href="#/project-grants/cost-allocation-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			case 'Third Party Integration Form':
				return `<a target="_blank" href="#/forms/third-party-integration-form/${formId}" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>`;

			case 'Investment Activity Recording Form':
				return (
					'<a target="_blank" href="#/generalledger/investment-activity-recording-form/' +
					formId +
					'" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>'
				);
			default:
				return '';
		}
	}

	public getFormLinkFormat(formLink: string): string {
		if (!formLink) {
			return '';
		}
		return `<a target="_blank" href="${formLink}" class="btn btn-sm btn-info" style="color:black;"><i class="fa fa-eye"></i></a>`;
	}

	GetFormLinkToRedirect(formId: string, formType: number): string {
		let url = '';

		switch (formType) {
			case FormOptions.CheckRequest:
				url = `/#/forms/check-request/${formId}`;
				break;
			case FormOptions.APInvoice:
				url = `/#/forms/ap-invoice/view/${formId}`;
				break;
			case FormOptions.QuickPayForm:
				url = `/#/forms/quick-pay/view/${formId}`;
				break;
			case FormOptions.Purchasing:
				url = `/#/forms/purchasing/view/${formId}`;
				break;
			case FormOptions.CashBondForm:
				url = `/#/forms/cash-bond-receipt-form/${formId}`;
				break;
			case FormOptions.IndividualPaymentForm:
				url = `/#/forms/individual-payment/view/${formId}`;
				break;
			case FormOptions.CashBondPaymentForm:
				url = `/#/forms/cash-bond-payment-form/${formId}`;
				break;
			case FormOptions.MultiplePayment:
				url = `/#/forms/multiple-payment/view/${formId}`;
				break;
			case FormOptions.BidForm:
				url = `/#/forms/bid-form/${formId}`;
				break;
			case FormOptions.OtherReimbursableExpensesForm:
				url = `/#/forms/other-reimbursable-expenses/${formId}`;
				break;
			case FormOptions.PCard:
				url = `/#/forms/p-card/view/${formId}`;
				break;
			case FormOptions.VoidReissueForm:
				url = `/#/forms/void-reissue-form/${formId}`;
				break;
			case FormOptions.PaymentAdjustmentForm:
				url = `/#/forms/payment-adjustment-form/${formId}`;
				break;
			case FormOptions.ChangeOrder:
				url = `/#/forms/change-order/view/${formId}`;
				break;
			case FormOptions.ContractApproval:
				url = `/#/forms/contract-approval/${formId}`;
				break;
			case FormOptions.PurchasingEmployee:
				url = `/#/forms/purchasing-employee-form/${formId}`;
				break;
			case FormOptions.PoRolloverForm:
				url = `/#/forms/po-rollover-form/${formId}`;
				break;
			case FormOptions.PoRollbackForm:
				url = `/#/forms/po-rollback-form/${formId}`;
				break;
			case FormOptions.VendorForm:
				url = `/#/forms/vendor-form/${formId}`;
				break;
			case FormOptions.CashReceiptForm:
				url = `/#/miscellaneous-billing/cash-receipt-form/${formId}`;
				break;
			case FormOptions.CashieringReport:
				url = `/#/forms/cashiering-report/view/${formId}`;
				break;
			case FormOptions.JournalEntryForm:
				url = `/#/generalledger/journal-form/${formId}`;
				break;
			case FormOptions.CustomerForm:
				url = `/#/miscellaneous-billing/customer-form/${formId}`;
				break;
			case FormOptions.CustomerInvoiceAdjustmentForm:
				url = `/#/miscellaneous-billing/customer-invoice-adjustment-form/${formId}`;
				break;
			case FormOptions.CustomerInvoiceForm:
				url = `/#/miscellaneous-billing/customer-invoice/${formId}`;
				break;
			case FormOptions.QuickInvoiceForm:
				url = `/#/miscellaneous-billing/quick-invoice/${formId}`;
				break;
			case FormOptions.Request:
				url = `/#/forms/request-form/view/${formId}`;
				break;
			case FormOptions.BudgetTransfer:
				url = `/#/forms/budget/transfer/view/${formId}`;
				break;
			case FormOptions.BudgetAmendment:
				url = `/#/forms/budget/amendment/view/${formId}`;
				break;
			case FormOptions.DptExpenseBudget:
				url = `/#/forms/budget/operating/${formId}`;
				break;
			case FormOptions.YeRequest:
				url = `/#/forms/ye-request/view/${formId}`;
				break;
			case FormOptions.FieldWorkRequest:
				url = `/#/forms/fieldwork-request/view/${formId}`;
				break;
			case FormOptions.NewProject:
				url = `/#/project-grants/new-project/view/${formId}`;
				break;
			case FormOptions.HRSupport:
				url = `/#/forms/hr-support/view/${formId}`;
				break;
			case FormOptions.TimeSheet:
				url = `/#/forms/timesheet/view/${formId}`;
				break;
			case FormOptions.MonthlyTimeSheet:
				url = `/#/forms/monthly-timesheet/${formId}`;
				break;
			case FormOptions.InvoiceApproval:
				url = `/#/forms/invoice-approval/${formId}`;
				break;
			case FormOptions.AclarianTask:
				url = `/#/forms/task-request/${formId}`;
				break;
			case FormOptions.CCApproval:
				url = `/#/forms/cc-approval/${formId}`;
				break;
			case FormOptions.VendorInformationChangeRequestForm:
				url = `/#/forms/vendor-information-change-request/edit/${formId}`;
				break;
			case FormOptions.BusinessLicense:
				url = `/#/licenses/license-form/edit/${formId}`;
				break;
			case FormOptions.NYRevenueBudget:
				url = `/#/forms/budget/revenue/${formId}`;
				break;
			case FormOptions.NYCapitalBudget:
				url = `/#/forms/budget/capital/${formId}`;
				break;
			case FormOptions.CapitalAdditionForm:
				url = `/#/capital-assets/addition-form/${formId}`;
				break;
			case FormOptions.CapitalDisposalForm:
				url = `/#/capital-assets/disposal-form/${formId}`;
				break;
			case FormOptions.CapitalTransferForm:
				url = `/#/capital-assets/transfer-form/${formId}`;
				break;
			case FormOptions.CapitalWorkOrderForm:
				url = `/#/capital-assets/asset-work-order-form/${formId}`;
				break;
			case FormOptions.DepartmentAdditionForm:
				url = `/#/generalledger/department-addition/${formId}`;
				break;
			case FormOptions.FundAdditionForm:
				url = `/#/generalledger/fund-addition-form/${formId}`;
				break;
			case FormOptions.ReceiptVerification:
				url = `/#/forms/receipt-verification/edit/${formId}`;
				break;
			case FormOptions.ProjectManagement:
				url = `/#/project-grants/project-mgt/${formId}`;
				break;
			case FormOptions.FundingIncreaseForm:
				url = `/#/project-grants/funding-increase-form/${formId}`;
				break;
			case FormOptions.PaymentApprovalForm:
				url = `/#/project-grants/payment-approval-form/${formId}`;
				break;
			case FormOptions.ProjectCloseForm:
				url = `/#/project-grants/project-close-form/${formId}`;
				break;
			case FormOptions.LeaseEvaluation:
				url = `/#/capital-lease/lease-evaluation/${formId}`;
				break;
			case FormOptions.PersonnelManagement:
				url = `/#/forms/budget/personnel/${formId}`;
				break;
			case FormOptions.AccountCreation:
				url = `/#/generalledger/gl-account/${formId}`;
				break;
			case FormOptions.ProjectOpenForm:
				url = `/#/project-grants/project-open-form/${formId}`;
				break;
			case FormOptions.BankReconciliation:
				url = `/#/generalledger/bank-reconciliation/${formId}`;
				break;
			case FormOptions.WorkOrderRequestForm:
				url = `/#/forms/work-order-request/view/${formId}`;
				break;
			case FormOptions.ProjectGrantForm:
				url = `/#/project-grants/project-grant-form/${formId}`;
				break;
			case FormOptions.ProjectGrantTask:
				url = `/#/project-grants/project-grant-task/${formId}`;
				break;
			case FormOptions.ProjectGrantCloseForm:
				url = `/#/project-grants/project-grant-close-form/${formId}`;
				break;
			case FormOptions.ProjectGrantReopenForm:
				url = `/#/project-grants/project-grant-reopen-form/${formId}`;
				break;
			case FormOptions.OpenClosePeriod:
				url = `/#/generalledger/open-close-period/${formId}`;
				break;
			case FormOptions.JobApplication:
				url = `/#/forms/hris/job-application/${formId}`;
				break;
			case FormOptions.EmployeeActionForm:
				url = `/#/forms/hris/employee/action/${formId}`;
				break;
			case FormOptions.TimeOff:
				url = `/#/forms/hris/timeoff/${formId}`;
				break;
			case FormOptions.HrisTimeSheet:
				url = `/#/forms/hris/weekly-timesheet/${formId}`;
				break;
			case FormOptions.PerformanceEvaluation:
				url = `/#/forms/hris/performance-evaluation/${formId}`;
				break;
			case FormOptions.BenefitEnrolmentForm:
				url = `/#/forms/hris/benefits-enrollment-form/${formId}`;
				break;
			case FormOptions.CreditCardReport:
				url = `/#/forms/credit-card-report/view/${formId}`;
				break;
			case FormOptions.IndividualPayeeForm:
				url = `/#/forms/individual-payee-form/${formId}`;
				break;
			case FormOptions.DepreciationScheduleForm:
				url = `/#/capital-assets/depreciation-schedule-form/${formId}`;
				break;
			case FormOptions.UsageForm:
				url = `/#/inventory-and-work-orders/usage-form/${formId}`;
				break;
			case FormOptions.CustomerRefundForm:
				url = `/#/forms/customer-refund-form/${formId}`;
				break;
			case FormOptions.NewCapitalLeaseForm:
				url = `/#/capital-lease/new-capital-lease-form/${formId}`;
				break;
			case FormOptions.NewDebtIssuanceForm:
				url = `/#/generalledger/new-debt-issuance-form/${formId}`;
				break;
			case FormOptions.DebtServicePaymentForm:
				url = `/#/generalledger/debt-service-payment-form/${formId}`;
				break;
			case FormOptions.DebtCovenantComplianceForm:
				url = `/#/generalledger/debt-covenant-compliance-form/${formId}`;
				break;
			case FormOptions.DebtInvestmentJournalEntryForm:
				url = `/#/generalledger/debt-investment-je-form/${formId}`;
				break;
			case FormOptions.InvestmentSecurityPurchaseForm:
				url = `/#/generalledger/investment-security-purchase-form/${formId}`;
				break;
			case FormOptions.UtilityApplication:
				url = `/#/utility-billing/application-form/edit/${formId}`;
				break;
			case FormOptions.CreateInvoiceForm:
				url = `/#/utility-billing/create-invoice-form/${formId}`;
				break;
			case FormOptions.LeaseModificationForm:
				url = `/#/capital-lease/lease-modification-form/${formId}`;
				break;
			case FormOptions.Implementation:
				url = `/#/forms/implementation-billing-ar-view/${formId}`;
				break;
			case FormOptions.ImplementationGL:
				url = `/#/forms/implementation-general-ledger-view/${formId}`;
				break;
			case FormOptions.NewHireForm:
				url = `/#/forms/hris/employee/create-employee/${formId}`;
				break;
			case FormOptions.ImplementationPurchasing:
				url = `/#/forms/implementation-purchasing-view/${formId}`;
				break;
			case FormOptions.LeaveBalanceAdjustmentForm:
				url = `/#/forms/hris/leave-balance-adjustment/${formId}`;
				break;
			case FormOptions.ImplementationPayment:
				url = `/#/forms/implementation-payment-view/${formId}`;
				break;
			case FormOptions.UserWorkflowForm:
				url = `/#/user-management/user-form/${formId}`;
				break;
			case FormOptions.WorkflowGroup:
				url = `/#/workflow-management/workflow-group-form/${formId}`;
				break;
			case FormOptions.TimeSheetApprovalForm:
				url = `/#/forms/hris/timesheet-approval-form/${formId}`;
				break;
			case FormOptions.ImplementationHR:
				url = `/#/forms/implementation-hr-view/${formId}`;
				break;
			case FormOptions.CapitalReclassification:
				url = `/#/capital-assets/reclassification/${formId}`;
				break;
			case FormOptions.TravelPreApprovalForm:
				url = `/#/forms/travel-pre-approval/${formId}`;
				break;
			case FormOptions.TravelReimbursementForm:
				url = `/#/forms/travel-reimbursement/${formId}`;
				break;
			case FormOptions.ElectronicAchReport:
				url = `/#/forms/electronic-ach-report/view/${formId}`;
				break;
			case FormOptions.ComplainantForm:
				url = `/#/code-enforcement/complainant-form/${formId}`;
				break;
			case FormOptions.RequestForm:
				url = `/#/forms/request-form/view/${formId}`;
				break;
			case FormOptions.TaxingJurisdiction:
				url = `/#/forms/taxing-jurisdiction-form/${formId}`;
				break;
			case FormOptions.TuitionReimbursementForm:
				url = `/#/forms/tuition-reimbursement/${formId}`;
				break;
			case FormOptions.TuitionReimbursementPaymentForm:
				url = `/#/forms/tuition-reimbursement-payment/${formId}`;
				break;
			case FormOptions.TaxDistributionForm:
				url = `/#/forms/tax-distribution/${formId}`;
				break;
			case FormOptions.Announcements:
				url = `/#/announcements/edit/${formId}`;
				break;
			case FormOptions.LocalVicinityTravelForm:
				url = `/#/forms/local-vicinity/${formId}`;
				break;
			case FormOptions.OutofCountyTravelForm:
				url = `/#/forms/out-of-county-travel/${formId}`;
				break;
			case FormOptions.FiservRefundForm:
				url = `/#/forms/fiserv-refund-form/${formId}`;
				break;
			case FormOptions.SpecialPayForm:
				url = `/#/forms/hris/special-pay-form/${formId}`;
				break;
			case FormOptions.TuitionReimbPreApprovalForm:
				url = `/#/forms/tuition-reimbursement-pre-approval/${formId}`;
				break;
			case FormOptions.InvestmentIncomeAllocationForm:
				url = `/#/generalledger/investment-income-allocation-form/${formId}`;
				break;
			case FormOptions.IndividualRefundForm:
				url = `/#/forms/individual-refund-form/${formId}`;
				break;
			case FormOptions.TaxCertificateRedemptionCheckForm:
				url = `/#/forms/tax-certificate-redemption-check/${formId}`;
				break;
			case FormOptions.TaxCertificateRedemptionACHForm:
				url = `/#/forms/tax-certificate-redemption-ach-form/${formId}`;
				break;
			case FormOptions.GoLiveApprovalForm:
				url = `/#/forms/go-live-approval-form/${formId}`;
				break;
			case FormOptions.TrainingCertificationForm:
				url = `/#/forms/training-certification-form/${formId}`;
				break;
			case FormOptions.LocationForm:
				url = `/#/inventory-and-work-orders/location-form/${formId}`;
				break;
			case FormOptions.ItemForm:
				url = `/#/inventory-and-work-orders/item-form/${formId}`;
				break;
			case FormOptions.ReceivingForm:
				url = `/#/inventory-and-work-orders/receiving-form/${formId}`;
				break;
			case FormOptions.NewCustomerForm:
				url = `/#/utility-billing/new-customer-form/${formId}`;
				break;
			case FormOptions.NewPropertyForm:
				url = `/#/utility-billing/new-property-form/${formId}`;
				break;
			case FormOptions.NewCustomerAccountForm:
				url = `/#/utility-billing/new-customer-account-form/${formId}`;
				break;
			case FormOptions.FeeAdjustmentForm:
				url = `/#/utility-billing/fee-adjustment-form/${formId}`;
				break;
			case FormOptions.UsageAdjustmentForm:
				url = `/#/utility-billing/usage-adjustment-form/${formId}`;
				break;
			case FormOptions.ManualMeterReadForm:
				url = `/#/utility-billing/manual-meter-read-form/${formId}`;
				break;
			case FormOptions.MeterTurnOnForm:
				url = `/#/utility-billing/meter-turn-on-form/${formId}`;
				break;
			case FormOptions.MeterTurnOffForm:
				url = `/#/utility-billing/meter-turn-off-form/${formId}`;
				break;
			case FormOptions.MassPayRateChangeForm:
				url = `/#/forms/hris/mass-pay-rate-change-form/${formId}`;
				break;
			case FormOptions.AdjustmentForm:
				url = `/#/inventory-and-work-orders/adjustment-form/${formId}`;
				break;
			case FormOptions.ImplementationPayroll:
				url = `/#/forms/implementation-payroll-view/${formId}`;
				break;
			case FormOptions.JuryCheckRegistryForm:
				url = `/#/forms/jury-check-registry-form/${formId}`;
				break;
			case FormOptions.TransactionAssignmentForm:
				url = `/#/project-grants/transaction-assignment-form/${formId}`;
				break;
			case FormOptions.LeaveBalancePayoutForm:
				url = `/#/forms/hris/leave-balance-payout-form/${formId}`;
				break;
			case FormOptions.PaymentPlanForm:
				url = `/#/utility-billing/payment-plan-form/${formId}`;
				break;
			case FormOptions.MeterChangeOutForm:
				url = `/#/utility-billing/meter-change-out-form/${formId}`;
				break;
			case FormOptions.PayrollAdjustmentForm:
				url = `/#/forms/hris/payroll-adjustment-form/${formId}`;
				break;
			case FormOptions.OtherBankReconciliation:
				url = `/#/generalledger/other-bank-reconciliation/${formId}`;
				break;
			case FormOptions.CustomerCreditMemo:
				url = `/#/miscellaneous-billing/customer-credit-memos/${formId}`;
				break;
			case FormOptions.VendorCreditMemo:
				url = `/#/forms/vendor-credit-memos/${formId}`;
				break;
			case FormOptions.FieldRequestPaymentForm:
				url = `/#/forms/field-purchase-order-request-form/${formId}`;
				break;
			case FormOptions.MultipleVendorPayment:
				url = `/#/forms/multiple-vendor-payment/${formId}`;
				break;
			case FormOptions.OtherTuitionReimbursementForm:
				url = `/#/forms/other-tuition-reimbursement/${formId}`;
				break;
			case FormOptions.OtherTuitionReimbursementPaymentForm:
				url = `/#/forms/other-tuition-reimbursement-payment/${formId}`;
				break;
			case FormOptions.NYOperatingExpenseBudget:
				url = `/#/forms/budget/operating-expense/${formId}`;
				break;
			case FormOptions.RestitutionPaymentForm:
				url = `/#/forms/restitution-payment-form/${formId}`;
				break;
			case FormOptions.CustomerFeedbackSurveyForm:
				url = `/#/forms/customer-feedback-survey/${formId}`;
				break;
			case FormOptions.SpecialPayment:
				url = `/#/forms/special-payment/${formId}`;
				break;
			case FormOptions.InitialPurchaseRequestForm:
				url = `/#/forms/initial-purchase-request-form/${formId}`;
				break;
			case FormOptions.BulkCashReceiptForm:
				url = `/#/miscellaneous-billing/bulk-cash-receipt-form/${formId}`;
				break;
			case FormOptions.DailyFeesImportForm:
				url = `/#/forms/daily-fees-import-form/view/${formId}`;
				break;
			case FormOptions.EmployeeReimbursableExpensesForm:
				url = `/#/forms/employee-reimbursable-expenses/${formId}`;
				break;
			case FormOptions.ContractAmendment:
				url = `/#/forms/contract-amendment/${formId}`;
				break;
			case FormOptions.CashieringAdjustmentForm:
				url = `/#/miscellaneous-billing/cashiering-adjustment-form/${formId}`;
				break;
			case FormOptions.CashieringCloseoutReport:
				url = `/#/forms/cashiering-closeout-report/view/${formId}`;
				break;
			case FormOptions.ParentVendorForm:
				url = `/#/forms/parent-vendor-form/edit/${formId}`;
				break;
			case FormOptions.NewHireRequestForm:
				url = `/#/forms/budget/new-hire-request-form/${formId}`;
				break;
			case FormOptions.PolicyForm:
				url = `/#/policies-procedures/policy-form/${formId}`;
				break;
			case FormOptions.ProcedureForm:
				url = `/#/policies-procedures/procedure-form/${formId}`;
				break;
			case FormOptions.OutofCountyTravelAdjustmentForm:
				url = `/#/forms/out-of-county-travel-adjustment/${formId}`;
				break;
			case FormOptions.TravelReimbursementPaymentForm:
				url = `/#/forms/travel-reimbursement-payment/${formId}`;
				break;
			case FormOptions.CustomizedTaskForm:
				url = `/#/forms/customized-task-form/view/${formId}`;
				break;
			case FormOptions.ProjectGrantComplianceForm:
				url = `/#/project-grants/project-grant-compliance-form/${formId}`;
				break;

			case FormOptions.ThirdPartyIntegrationForm:
				url = `/#/forms/third-party-integration-form/view/${formId}`;
				break;
			case FormOptions.InvestmentActivityRecordingForm:
				url = `/#/generalledger/investment-activity-recording-form/${formId}`;
				break;
			case FormOptions.CustomizationRequestForm:
				url = `/#/forms/customization-request-form/${formId}`;
				break;
			case FormOptions.AccessChangeForm:
				url = `/#/user-management/access-change-form/${formId}`;
				break;
			case FormOptions.MassInvoiceCreationForm:
				url = `/#/miscellaneous-billing/mass-invoice-creation-form/${formId}`;
				break;
			case FormOptions.BillingForm:
				url = `/#/billing-forms/billing-form/${formId}`;
				break;
			default:
				url = '/';
		}

		// Open in new tab
		return url;
	}

	public getFormLinkOnly(formId: string, sourceName: string): string {
		switch (sourceName) {
			case 'Quick Pay':
			case 'Quick Pay Form':
				return `#/forms/quick-pay/${formId}`;

			case 'P-Card':
			case 'P-Card Form':
				return `#/forms/p-card/${formId}`;

			case 'Check Request Form':
			case 'CheckRequest':
			case 'Check Request':
				return `#/forms/check-request/${formId}`;

			case 'Individual Payment Form':
				return `#/forms/individual-payment/${formId}`;

			case 'Customer Refund Form':
				return `#/forms/customer-refund-form/${formId}`;

			case 'Invoice Approval Form w/PO':
			case 'APInvoice':
			case 'AP Invoice Form':
				return `#/forms/ap-invoice/${formId}`;

			case 'Fiserv Refund Form':
				return `#/forms/fiserv-refund-form/${formId}`;

			case 'Out Of County Travel':
				return `#/forms/out-of-county-travel/${formId}`;

			case 'Local Vicinity Travel':
				return `#/forms/local-vicinity/${formId}`;

			case 'Other Reimbursable Expenses':
				return `#/forms/other-reimbursable-expenses/${formId}`;

			case 'Individual Refund Form Detail':
			case 'IndividualRefundFormDetail':
				return `#/forms/individual-refund-form/${formId}`;

			case 'Tax Certificate Redemption Check Form Detail':
				return `#/forms/tax-certificate-redemption-check/${formId}`;

			case 'Tuition Reimbursement Payment':
				return `#/forms/tuition-reimbursement-payment/${formId}`;

			case 'Tuition Reimbursement':
				return `#/forms/tuition-reimbursement/${formId}`;

			case 'Tax Distribution':
			case 'tax-distribution':
				return `#/forms/tax-distribution/${formId}`;

			case 'Tax Certificate Redemption ACH Form':
				return `#/forms/tax-certificate-redemption-ach-form/${formId}`;

			case 'Jury Check Registry Form':
			case 'Jury Check Registry Form Detail':
				return `#/forms/jury-check-registry-form/${formId}`;

			case 'Journal Entry Form':
			case 'JournalEntry':
				return `#/generalledger/journal-form/${formId}`;

			case 'VoidReissueForm':
				return `#/forms/void-reissue-form/${formId}`;

			case 'PaymentAdjustmentForm':
				return `#/forms/payment-adjustment-form/${formId}`;

			case 'Multiple Payment':
				return `#/forms/multiple-payment/view/${formId}`;

			case 'Invoice Form':
				return `#/miscellaneous-billing/customer-invoice/${formId}`;

			case 'Multiple Vendor Payment':
				return `#/forms/multiple-vendor-payment/${formId}`;
			case 'Multiple Payee Payment':
				return `#/forms/multiple-vendor-payment/${formId}`;
			case 'ElectronicAchReport':
			case 'Electronic/ACH Report':
				return `#/forms/electronic-ach-report/${formId}`;

			case 'Other Tuition Reimbursement Payment':
				return `#/forms/other-tuition-reimbursement-payment/${formId}`;

			case 'Quick Invoice Form':
				return `#/miscellaneous-billing/quick-invoice/${formId}`;

			case 'Cash Receipt Form':
				return `#/miscellaneous-billing/cash-receipt-form/${formId}`;

			case 'Cash Bond Payee':
				return `#/forms/cash-bond-payment-form/${formId}`;

			case 'Restitution Payment Form Detail':
				return `#/forms/restitution-payment-form/${formId}`;

			case 'Special Payment':
				return `#/forms/special-payment/${formId}`;

			case 'Bulk Cash Receipt Form':
				return `#/miscellaneous-billing/bulk-cash-receipt-form/${formId}`;

			case 'Daily-fees Import Form':
				return `#/forms/daily-fees-import-form/${formId}`;

			case 'Cashiering Adjustment Form':
				return `#/miscellaneous-billing/cashiering-adjustment-form/${formId}`;

			case 'Cashiering Closeout Report':
				return `#/forms/cashiering-closeout-report/${formId}`;

			case 'Employee Reimbursable Expenses':
				return `#/forms/employee-reimbursable-expenses/${formId}`;

			case 'Out Of County Travel Adjustment':
				return `#/forms/out-of-county-travel-adjustment/${formId}`;

			case 'Travel Reimbursement':
				return `#/forms/travel-reimbursement-payment/${formId}`;

			case 'Cost Allocation Form':
				return `#/project-grants/cost-allocation-form/${formId}`;

			case 'Investment Activity Recording Form':
				return `#/generalledger/investment-activity-recording-form/${formId}`;

			case 'Third Party Integration Form':
				return `#/forms/third-party-integration-form/${formId}`;

			default:
				return '';
		}
	}
}
